import React from "react";

export const HealthparamsLogo = () => (
  <svg
    className="app-logo"
    version="1.1"
    id="svg2"
    width="1133.8586"
    height="1133.8586"
    viewBox="0 0 1133.8586 1133.8586"
  >
    <g
      className="wrapper"
      transform="matrix(1.3333333,0,0,-1.3333333,0,1133.8587)"
    >
      <g id="g14" className="container">
        <g id="g16" clipPath="url(#clipPath20)">
          <g id="g22">
            <g id="g24" />
            <g id="g944">
              <g clipPath="url(#clipPath28)" opacity="0.399994" id="g942">
                <g id="g268">
                  <g id="g258" />
                  <g id="g266">
                    <g clipPath="url(#clipPath32)" id="g264">
                      <g
                        className="layer-container"
                        transform="translate(315.6978,531.6113)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c 2.593,7.627 5.263,15.256 7.17,23.037 2.212,8.848 2.518,16.705 1.45,25.707 -2.06,18.842 -8.391,38.598 -14.494,56.526 -7.323,21.511 -0.381,45.462 17.392,59.728 9.611,7.781 21.664,12.053 34.021,12.053 9.917,0 19.68,-2.746 28.148,-7.934 14.798,-8.849 28.834,-18.994 42.41,-29.521 26.852,-20.825 52.328,-44.397 73.306,-71.172 16.401,-20.901 30.436,-44.397 38.447,-69.873 1.754,-5.416 5.948,-9.155 11.516,-10.299 54.539,-11.289 128.531,-37.303 128.531,-100.922 0,-102.369 -53.394,-200.926 -145.084,-249.137 -35.011,-18.384 -73.687,-28.072 -113.351,-28.072 -39.666,0 -78.416,9.688 -113.505,28.225 -91.536,48.134 -144.856,146.689 -144.856,248.984 0,66.518 80.552,92.072 137.228,102.6 C -6.103,-9.002 -1.831,-5.34 0,0"
                            style={{
                              fill: "#ffffff",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path260"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g280">
                  <g id="g270" />
                  <g id="g278">
                    <g clipPath="url(#clipPath36)" id="g276">
                      <g
                        className="layer-container"
                        transform="translate(310.2114,637.0126)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.194,18.193 -2.104,38.145 10.161,52.403 2.153,2.504 4.563,4.826 7.203,6.942 5.494,4.404 11.764,7.684 18.439,9.66 4.975,1.472 10.167,2.224 15.41,2.203 3.152,-0.013 6.288,-0.305 9.369,-0.868 6.549,-1.195 12.845,-3.624 18.587,-7.105 14.663,-8.886 28.668,-18.899 42.164,-29.364 26.823,-20.803 52.28,-44.354 73.235,-71.1 16.386,-20.881 30.302,-44.394 38.4,-69.816 0.874,-2.743 2.385,-5.057 4.362,-6.834 1.925,-1.733 4.316,-2.948 7.043,-3.537 3.486,-0.759 7.066,-1.563 10.711,-2.414 52.881,-12.347 117.79,-38.842 117.892,-98.242 0.128,-101.726 -53.311,-200.635 -144.865,-248.774 -34.955,-18.355 -73.565,-28.026 -113.162,-28.026 -39.601,0 -78.284,9.671 -113.315,28.177 -91.403,48.065 -144.638,146.481 -144.638,248.623 0,57.695 61.152,84.433 114.04,97.301 5.504,1.338 10.904,2.583 16.1,3.73 2.451,0.537 4.87,1.04 7.244,1.527 5.503,1.13 9.728,4.835 11.557,10.174 1.517,4.464 3.057,8.928 4.454,13.422 0.993,3.194 1.903,6.404 2.697,9.636 1.933,7.872 2.401,14.961 1.723,22.776 -0.084,0.97 -0.19,1.951 -0.304,2.947 C 12.353,-37.715 6.104,-17.937 0,0"
                            style={{
                              fill: "#fefefe",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path272"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g292">
                  <g id="g282" />
                  <g id="g290">
                    <g clipPath="url(#clipPath40)" id="g288">
                      <g
                        className="layer-container"
                        transform="translate(310.5981,637.1454)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.16,18.088 -2.069,37.928 10.159,52.078 2.148,2.485 4.549,4.787 7.178,6.884 5.472,4.362 11.715,7.602 18.356,9.543 4.951,1.444 10.113,2.172 15.322,2.129 3.131,-0.027 6.245,-0.329 9.303,-0.904 6.5,-1.214 12.752,-3.644 18.461,-7.108 14.575,-8.843 28.502,-18.805 41.916,-29.206 26.794,-20.78 52.233,-44.312 73.165,-71.03 16.37,-20.861 30.275,-44.357 38.353,-69.759 0.87,-2.737 2.366,-5.055 4.317,-6.846 1.902,-1.749 4.27,-2.984 6.977,-3.595 3.463,-0.792 7.035,-1.616 10.679,-2.461 52.751,-12.268 117.792,-38.657 117.995,-97.929 0.256,-101.083 -53.227,-200.346 -144.646,-248.412 -34.897,-18.324 -73.442,-27.98 -112.973,-27.98 -39.536,0 -78.152,9.656 -113.124,28.13 -91.269,47.995 -144.42,146.273 -144.42,248.262 0,57.671 61.655,84.272 114.356,97.028 5.51,1.331 10.896,2.626 16.029,3.857 2.42,0.571 4.808,1.115 7.155,1.632 5.432,1.219 9.617,4.939 11.444,10.277 1.516,4.467 3.054,8.934 4.447,13.432 0.99,3.2 1.896,6.412 2.683,9.645 1.916,7.87 2.376,14.969 1.694,22.793 -0.085,0.97 -0.191,1.951 -0.305,2.949 C 12.36,-37.735 6.106,-17.945 0,0"
                            style={{
                              fill: "#fcfcfc",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path284"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g304">
                  <g id="g294" />
                  <g id="g302">
                    <g clipPath="url(#clipPath44)" id="g300">
                      <g
                        className="layer-container"
                        transform="translate(310.9849,637.2773)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.125,17.983 -2.035,37.711 10.158,51.755 2.141,2.465 4.529,4.753 7.152,6.824 5.44,4.332 11.665,7.522 18.273,9.425 4.926,1.418 10.059,2.121 15.232,2.057 3.112,-0.04 6.204,-0.355 9.24,-0.94 6.451,-1.233 12.659,-3.665 18.334,-7.111 14.487,-8.799 28.336,-18.709 41.67,-29.049 26.765,-20.758 52.184,-44.269 73.093,-70.959 16.356,-20.841 30.252,-44.318 38.307,-69.7 0.867,-2.735 2.347,-5.056 4.272,-6.861 1.877,-1.764 4.223,-3.018 6.91,-3.653 3.44,-0.827 7.003,-1.666 10.646,-2.51 52.622,-12.187 117.793,-38.469 118.098,-97.614 0.386,-100.44 -53.142,-200.056 -144.426,-248.05 -34.841,-18.295 -73.32,-27.932 -112.784,-27.932 -39.47,0 -78.02,9.637 -112.933,28.081 -91.136,47.926 -144.202,146.063 -144.202,247.901 0,57.648 62.157,84.111 114.672,96.756 5.517,1.325 10.884,2.682 15.958,3.982 2.388,0.613 4.747,1.185 7.066,1.738 5.363,1.294 9.505,5.043 11.33,10.381 1.516,4.47 3.052,8.941 4.441,13.441 0.988,3.205 1.889,6.421 2.67,9.654 1.901,7.869 2.35,14.978 1.664,22.809 -0.085,0.972 -0.192,1.954 -0.307,2.951 C 12.365,-37.758 6.109,-17.953 0,0"
                            style={{
                              fill: "#fbfbfb",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path296"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g316">
                  <g id="g306" />
                  <g id="g314">
                    <g clipPath="url(#clipPath48)" id="g312">
                      <g
                        className="layer-container"
                        transform="translate(311.3716,637.4091)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.089,17.88 -2.001,37.495 10.156,51.43 2.135,2.447 4.519,4.71 7.126,6.765 5.428,4.281 11.616,7.442 18.191,9.31 4.901,1.391 10.004,2.069 15.144,1.983 3.09,-0.052 6.16,-0.381 9.174,-0.975 6.403,-1.255 12.567,-3.687 18.208,-7.117 14.398,-8.756 28.169,-18.614 41.422,-28.889 26.737,-20.737 52.138,-44.228 73.023,-70.889 16.34,-20.82 30.23,-44.281 38.26,-69.642 0.864,-2.732 2.328,-5.055 4.228,-6.874 1.852,-1.781 4.175,-3.053 6.842,-3.712 3.418,-0.86 6.972,-1.718 10.614,-2.556 52.493,-12.109 117.796,-38.284 118.202,-97.302 0.514,-99.798 -53.058,-199.765 -144.207,-247.687 -34.783,-18.265 -73.197,-27.887 -112.594,-27.887 -39.405,0 -77.889,9.622 -112.743,28.033 -91.002,47.859 -143.984,145.857 -143.984,247.541 0,57.623 62.66,83.951 114.989,96.484 5.523,1.318 10.874,2.726 15.886,4.108 2.356,0.649 4.687,1.255 6.977,1.843 5.295,1.369 9.393,5.146 11.216,10.484 1.516,4.474 3.051,8.948 4.435,13.452 0.986,3.209 1.882,6.427 2.657,9.663 1.883,7.868 2.325,14.985 1.634,22.825 -0.085,0.972 -0.193,1.955 -0.308,2.952 C 12.37,-37.779 6.111,-17.963 0,0"
                            style={{
                              fill: "#f9f9f9",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path308"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g328">
                  <g id="g318" />
                  <g id="g326">
                    <g clipPath="url(#clipPath52)" id="g324">
                      <g
                        className="layer-container"
                        transform="translate(311.7583,637.5419)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.054,17.774 -1.967,37.277 10.154,51.104 2.129,2.428 4.504,4.672 7.101,6.708 5.407,4.238 11.566,7.36 18.108,9.192 4.876,1.364 9.95,2.017 15.055,1.909 3.07,-0.064 6.118,-0.405 9.109,-1.011 6.355,-1.274 12.475,-3.706 18.081,-7.119 14.312,-8.713 28.004,-18.518 41.175,-28.732 26.709,-20.716 52.09,-44.186 72.952,-70.819 16.327,-20.799 30.204,-44.242 38.215,-69.585 0.862,-2.725 2.309,-5.053 4.183,-6.887 1.827,-1.795 4.131,-3.081 6.774,-3.77 3.398,-0.885 6.942,-1.768 10.582,-2.602 52.365,-12.031 117.797,-38.098 118.305,-96.989 0.643,-99.155 -52.973,-199.475 -143.987,-247.325 -34.726,-18.234 -73.075,-27.84 -112.405,-27.84 -39.339,0 -77.756,9.606 -112.552,27.986 -90.869,47.788 -143.766,145.647 -143.766,247.179 0,57.599 63.162,83.79 115.305,96.211 5.53,1.312 10.864,2.776 15.816,4.235 2.323,0.684 4.625,1.324 6.887,1.948 5.226,1.443 9.281,5.251 11.103,10.587 1.516,4.478 3.048,8.956 4.428,13.463 0.983,3.215 1.875,6.435 2.644,9.673 1.867,7.865 2.299,14.991 1.605,22.839 -0.087,0.973 -0.194,1.957 -0.309,2.955 C 12.377,-37.802 6.114,-17.972 0,0"
                            style={{
                              fill: "#f8f8f8",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path320"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g340">
                  <g id="g330" />
                  <g id="g338">
                    <g clipPath="url(#clipPath56)" id="g336">
                      <g
                        className="layer-container"
                        transform="translate(312.1455,637.6728)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -6.02,17.67 -1.933,37.063 10.152,50.781 2.122,2.409 4.489,4.632 7.076,6.648 5.384,4.197 11.516,7.279 18.024,9.076 4.852,1.337 9.896,1.966 14.967,1.836 3.049,-0.078 6.076,-0.429 9.044,-1.046 6.306,-1.295 12.382,-3.728 17.955,-7.124 14.223,-8.67 27.838,-18.424 40.928,-28.574 26.68,-20.694 52.042,-44.143 72.881,-70.746 16.31,-20.781 30.181,-44.206 38.168,-69.529 0.858,-2.721 2.29,-5.053 4.138,-6.9 1.803,-1.811 4.084,-3.115 6.708,-3.828 3.375,-0.918 6.91,-1.821 10.549,-2.65 52.235,-11.952 117.799,-37.912 118.409,-96.676 0.771,-98.512 -52.889,-199.184 -143.769,-246.962 -34.669,-18.204 -72.952,-27.795 -112.215,-27.795 -39.274,0 -77.624,9.591 -112.362,27.939 -90.735,47.718 -143.548,145.44 -143.548,246.818 0,57.575 63.665,83.629 115.621,95.938 5.537,1.307 10.855,2.824 15.746,4.362 2.292,0.721 4.565,1.394 6.798,2.054 5.158,1.518 9.169,5.354 10.989,10.69 1.516,4.481 3.045,8.962 4.422,13.473 0.981,3.219 1.867,6.442 2.63,9.681 1.851,7.864 2.274,14.999 1.575,22.855 -0.087,0.975 -0.195,1.959 -0.31,2.956 C 12.382,-37.821 6.116,-17.979 0,0"
                            style={{
                              fill: "#f7f7f7",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path332"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g352">
                  <g id="g342" />
                  <g id="g350">
                    <g clipPath="url(#clipPath60)" id="g348">
                      <g
                        className="layer-container"
                        transform="translate(312.5322,637.8056)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.985,17.564 -1.898,36.846 10.151,50.456 2.115,2.39 4.47,4.599 7.05,6.589 5.353,4.165 11.466,7.199 17.942,8.959 4.826,1.31 9.84,1.914 14.877,1.763 3.028,-0.091 6.034,-0.454 8.98,-1.081 6.257,-1.316 12.29,-3.748 17.828,-7.127 14.136,-8.626 27.672,-18.33 40.68,-28.418 26.652,-20.671 51.994,-44.1 72.811,-70.676 16.296,-20.76 30.156,-44.168 38.121,-69.471 0.855,-2.716 2.271,-5.053 4.095,-6.913 1.777,-1.826 4.037,-3.149 6.639,-3.887 3.354,-0.949 6.878,-1.871 10.518,-2.697 52.104,-11.872 117.8,-37.726 118.511,-96.362 0.9,-97.868 -52.804,-198.894 -143.549,-246.6 -34.612,-18.175 -72.829,-27.748 -112.026,-27.748 -39.209,0 -77.492,9.573 -112.17,27.891 -90.602,47.648 -143.331,145.23 -143.331,246.457 0,57.551 64.167,83.469 115.937,95.666 5.544,1.3 10.845,2.871 15.675,4.488 2.26,0.757 4.504,1.463 6.709,2.159 5.09,1.593 9.057,5.457 10.875,10.793 1.516,4.485 3.043,8.97 4.416,13.483 0.979,3.224 1.86,6.45 2.617,9.691 1.834,7.862 2.248,15.006 1.545,22.871 -0.087,0.975 -0.195,1.96 -0.312,2.958 C 12.389,-37.844 6.119,-17.988 0,0"
                            style={{
                              fill: "#f5f5f5",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path344"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g364">
                  <g id="g354" />
                  <g id="g362">
                    <g clipPath="url(#clipPath64)" id="g360">
                      <g
                        className="layer-container"
                        transform="translate(312.9189,637.9374)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.95,17.46 -1.864,36.629 10.149,50.131 2.109,2.371 4.455,4.559 7.024,6.53 5.332,4.124 11.417,7.118 17.86,8.843 4.802,1.284 9.786,1.862 14.788,1.689 3.008,-0.104 5.992,-0.479 8.915,-1.117 6.208,-1.335 12.197,-3.767 17.701,-7.131 14.048,-8.583 27.506,-18.234 40.434,-28.258 26.623,-20.65 51.947,-44.059 72.74,-70.605 16.28,-20.741 30.131,-44.131 38.075,-69.414 0.852,-2.711 2.252,-5.052 4.049,-6.927 1.754,-1.842 3.991,-3.184 6.573,-3.945 3.33,-0.982 6.847,-1.923 10.484,-2.744 51.977,-11.793 117.803,-37.54 118.616,-96.049 1.029,-97.227 -52.72,-198.604 -143.329,-246.238 -34.555,-18.144 -72.707,-27.702 -111.838,-27.702 -39.143,0 -77.359,9.558 -111.98,27.844 -90.468,47.579 -143.112,145.023 -143.112,246.096 0,57.527 64.67,83.309 116.254,95.393 5.55,1.293 10.834,2.916 15.603,4.615 2.228,0.793 4.444,1.532 6.619,2.263 5.022,1.668 8.947,5.562 10.762,10.896 1.516,4.489 3.041,8.977 4.41,13.494 0.976,3.23 1.853,6.458 2.604,9.7 1.818,7.862 2.223,15.013 1.516,22.888 -0.088,0.976 -0.197,1.961 -0.313,2.96 C 12.396,-37.865 6.121,-17.998 0,0"
                            style={{
                              fill: "#f4f4f4",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path356"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g376">
                  <g id="g366" />
                  <g id="g374">
                    <g clipPath="url(#clipPath68)" id="g372">
                      <g
                        className="layer-container"
                        transform="translate(313.3062,638.0703)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.915,17.355 -1.831,36.412 10.147,49.808 2.103,2.35 4.441,4.519 6.999,6.47 5.31,4.082 11.367,7.037 17.776,8.726 4.778,1.257 9.732,1.809 14.7,1.615 2.987,-0.117 5.949,-0.504 8.85,-1.152 6.16,-1.356 12.104,-3.789 17.574,-7.135 13.961,-8.539 27.341,-18.138 40.187,-28.101 26.594,-20.628 51.899,-44.016 72.669,-70.534 16.266,-20.719 30.108,-44.093 38.029,-69.356 0.849,-2.708 2.233,-5.052 4.005,-6.941 1.728,-1.856 3.943,-3.217 6.505,-4.003 3.308,-1.014 6.816,-1.973 10.453,-2.79 51.846,-11.716 117.803,-37.354 118.718,-95.736 1.158,-96.583 -52.635,-198.313 -143.111,-245.875 -34.497,-18.115 -72.584,-27.655 -111.647,-27.655 -39.078,0 -77.227,9.54 -111.789,27.795 -90.335,47.51 -142.895,144.814 -142.895,245.735 0,57.503 65.173,83.148 116.57,95.12 5.557,1.287 10.824,2.963 15.533,4.741 2.196,0.83 4.381,1.607 6.53,2.369 4.949,1.753 8.835,5.666 10.648,11 1.516,4.492 3.039,8.985 4.403,13.503 0.975,3.235 1.847,6.466 2.591,9.709 1.802,7.86 2.198,15.021 1.486,22.905 -0.088,0.975 -0.197,1.961 -0.314,2.961 C 12.401,-37.887 6.123,-18.006 0,0"
                            style={{
                              fill: "#f2f2f2",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path368"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g388">
                  <g id="g378" />
                  <g id="g386">
                    <g clipPath="url(#clipPath72)" id="g384">
                      <g
                        className="layer-container"
                        transform="translate(313.6929,638.2021)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.88,17.251 -1.796,36.196 10.146,49.482 2.096,2.333 4.429,4.478 6.972,6.413 5.297,4.03 11.318,6.956 17.695,8.608 4.752,1.23 9.676,1.759 14.61,1.543 2.967,-0.13 5.907,-0.529 8.785,-1.189 6.111,-1.375 12.012,-3.808 17.448,-7.137 13.872,-8.496 27.174,-18.044 39.94,-27.944 26.565,-20.606 51.851,-43.973 72.598,-70.464 16.25,-20.7 30.083,-44.054 37.983,-69.297 0.845,-2.703 2.214,-5.051 3.96,-6.954 1.704,-1.873 3.896,-3.253 6.437,-4.062 3.286,-1.046 6.784,-2.024 10.421,-2.838 51.717,-11.637 117.923,-37.165 118.821,-95.422 1.48,-95.937 -52.55,-198.024 -142.891,-245.513 -34.44,-18.085 -72.461,-27.61 -111.458,-27.61 -39.012,0 -77.095,9.525 -111.598,27.748 -90.201,47.441 -142.677,144.607 -142.677,245.375 0,57.478 65.675,82.988 116.886,94.848 5.564,1.28 10.814,3.01 15.463,4.867 2.163,0.865 4.318,1.677 6.44,2.474 4.879,1.832 8.723,5.77 10.535,11.102 1.515,4.496 3.036,8.992 4.396,13.515 0.973,3.239 1.839,6.474 2.577,9.72 1.786,7.856 2.173,15.026 1.457,22.918 -0.089,0.976 -0.198,1.963 -0.315,2.963 C 12.406,-37.908 6.125,-18.015 0,0"
                            style={{
                              fill: "#f1f1f1",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path380"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g400">
                  <g id="g390" />
                  <g id="g398">
                    <g clipPath="url(#clipPath76)" id="g396">
                      <g
                        className="layer-container"
                        transform="translate(314.0796,638.3349)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.845,17.145 -1.762,35.979 10.145,49.157 2.089,2.314 4.41,4.443 6.946,6.354 5.267,3.999 11.268,6.876 17.611,8.491 4.729,1.205 9.623,1.707 14.522,1.47 2.946,-0.144 5.864,-0.56 8.72,-1.224 6.06,-1.408 11.92,-3.83 17.322,-7.143 13.785,-8.452 27.008,-17.948 39.693,-27.785 26.536,-20.584 51.803,-43.931 72.526,-70.392 16.237,-20.68 30.059,-44.018 37.937,-69.241 0.843,-2.699 2.2,-5.047 3.915,-6.967 1.684,-1.884 3.851,-3.286 6.371,-4.119 3.264,-1.08 6.753,-2.078 10.389,-2.886 51.588,-11.558 117.934,-36.98 118.924,-95.109 1.624,-95.295 -52.466,-197.735 -142.671,-245.151 -34.383,-18.055 -72.339,-27.562 -111.269,-27.562 -38.948,0 -76.964,9.507 -111.408,27.7 -90.068,47.37 -142.459,144.397 -142.459,245.013 0,57.455 66.178,82.827 117.203,94.575 5.57,1.274 10.803,3.056 15.391,4.994 2.131,0.9 4.258,1.748 6.351,2.579 4.81,1.909 8.611,5.874 10.421,11.206 1.516,4.499 3.034,8.999 4.391,13.524 0.969,3.245 1.832,6.482 2.563,9.729 1.77,7.855 2.148,15.034 1.427,22.934 -0.089,0.978 -0.198,1.964 -0.316,2.964 C 12.414,-37.932 6.128,-18.024 0,0"
                            style={{
                              fill: "#f0eff0",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path392"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g412">
                  <g id="g402" />
                  <g id="g410">
                    <g clipPath="url(#clipPath80)" id="g408">
                      <g
                        className="layer-container"
                        transform="translate(314.4663,638.4667)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.81,17.041 -1.728,35.764 10.143,48.833 2.083,2.295 4.396,4.404 6.92,6.295 5.246,3.957 11.219,6.795 17.529,8.376 4.704,1.177 9.569,1.654 14.433,1.395 2.926,-0.156 5.822,-0.585 8.656,-1.259 6.01,-1.431 11.827,-3.851 17.195,-7.147 13.696,-8.409 26.842,-17.853 39.445,-27.626 26.508,-20.563 51.756,-43.889 72.456,-70.322 16.221,-20.661 30.036,-43.981 37.89,-69.184 0.841,-2.695 2.181,-5.046 3.871,-6.98 1.659,-1.9 3.804,-3.32 6.304,-4.178 3.242,-1.112 6.721,-2.128 10.355,-2.932 51.459,-11.479 117.947,-36.793 119.029,-94.796 1.766,-94.652 -52.382,-197.445 -142.454,-244.788 -34.325,-18.026 -72.215,-27.517 -111.078,-27.517 -38.882,0 -76.831,9.491 -111.217,27.653 -89.935,47.3 -142.241,144.189 -142.241,244.652 0,57.43 66.68,82.666 117.518,94.302 5.578,1.269 10.794,3.102 15.321,5.12 2.1,0.937 4.196,1.819 6.262,2.684 4.741,1.985 8.499,5.979 10.307,11.31 1.516,4.502 3.033,9.006 4.384,13.534 0.968,3.249 1.826,6.489 2.551,9.738 1.753,7.854 2.122,15.042 1.398,22.951 -0.091,0.978 -0.201,1.966 -0.319,2.965 C 12.418,-37.952 6.131,-18.032 0,0"
                            style={{
                              fill: "#eeeeee",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path404"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g424">
                  <g id="g414" />
                  <g id="g422">
                    <g clipPath="url(#clipPath84)" id="g420">
                      <g
                        className="layer-container"
                        transform="translate(314.853,638.5986)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.774,16.937 -1.694,35.547 10.141,48.51 2.077,2.275 4.381,4.364 6.896,6.234 5.223,3.916 11.169,6.715 17.445,8.259 4.679,1.15 9.514,1.603 14.344,1.322 2.905,-0.169 5.779,-0.609 8.591,-1.294 5.962,-1.451 11.734,-3.872 17.068,-7.15 13.609,-8.366 26.677,-17.759 39.199,-27.469 26.479,-20.541 51.708,-43.848 72.385,-70.252 16.205,-20.639 30.012,-43.941 37.844,-69.126 0.837,-2.69 2.162,-5.046 3.826,-6.993 1.635,-1.915 3.757,-3.355 6.236,-4.236 3.219,-1.144 6.69,-2.179 10.324,-2.98 51.329,-11.399 117.957,-36.605 119.132,-94.482 1.908,-94.007 -52.298,-197.154 -142.234,-244.426 -34.268,-17.995 -72.093,-27.47 -110.89,-27.47 -38.816,0 -76.699,9.475 -111.026,27.604 -89.801,47.232 -142.023,143.98 -142.023,244.292 0,57.406 67.182,82.505 117.835,94.029 5.584,1.263 10.782,3.149 15.249,5.247 2.068,0.971 4.136,1.889 6.173,2.789 4.671,2.064 8.387,6.082 10.193,11.412 1.517,4.506 3.031,9.014 4.378,13.546 0.966,3.254 1.818,6.497 2.538,9.747 1.737,7.853 2.096,15.048 1.368,22.966 -0.091,0.979 -0.201,1.968 -0.32,2.968 C 12.423,-37.973 6.133,-18.041 0,0"
                            style={{
                              fill: "#ededed",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path416"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g436">
                  <g id="g426" />
                  <g id="g434">
                    <g clipPath="url(#clipPath88)" id="g432">
                      <g
                        className="layer-container"
                        transform="translate(315.2402,638.7304)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.74,16.832 -1.66,35.331 10.139,48.185 2.07,2.255 4.366,4.326 6.87,6.177 5.201,3.873 11.119,6.632 17.363,8.141 4.654,1.124 9.46,1.552 14.255,1.249 2.884,-0.183 5.737,-0.635 8.526,-1.329 5.913,-1.472 11.642,-3.893 16.942,-7.155 13.52,-8.324 26.51,-17.664 38.951,-27.311 26.451,-20.52 51.661,-43.806 72.315,-70.181 16.19,-20.621 29.987,-43.904 37.797,-69.068 0.834,-2.686 2.143,-5.045 3.781,-7.008 1.61,-1.929 3.711,-3.389 6.169,-4.294 3.197,-1.177 6.659,-2.23 10.292,-3.026 51.199,-11.32 117.967,-36.42 119.234,-94.169 2.05,-93.365 -52.213,-196.864 -142.013,-244.064 -34.211,-17.964 -71.971,-27.423 -110.701,-27.423 -38.751,0 -76.567,9.459 -110.836,27.556 -89.667,47.162 -141.804,143.772 -141.804,243.931 0,57.382 67.684,82.345 118.15,93.757 5.591,1.256 10.773,3.193 15.179,5.373 2.036,1.007 4.074,1.959 6.083,2.893 4.601,2.141 8.276,6.187 10.08,11.516 1.517,4.511 3.028,9.021 4.372,13.556 0.963,3.259 1.811,6.505 2.524,9.756 1.721,7.851 2.071,15.056 1.338,22.982 -0.091,0.98 -0.201,1.97 -0.32,2.97 C 12.429,-37.995 6.135,-18.05 0,0"
                            style={{
                              fill: "#ebebeb",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path428"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g448">
                  <g id="g438" />
                  <g id="g446">
                    <g clipPath="url(#clipPath92)" id="g444">
                      <g
                        className="layer-container"
                        transform="translate(315.627,638.8622)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.705,16.727 -1.626,35.114 10.138,47.86 2.064,2.238 4.351,4.287 6.844,6.119 5.18,3.831 11.07,6.551 17.28,8.025 4.629,1.096 9.405,1.499 14.166,1.175 2.864,-0.196 5.695,-0.661 8.461,-1.366 5.864,-1.493 11.55,-3.912 16.816,-7.158 13.432,-8.28 26.343,-17.568 38.704,-27.153 26.422,-20.497 51.612,-43.763 72.244,-70.109 16.176,-20.6 29.965,-43.866 37.751,-69.01 0.83,-2.683 2.125,-5.045 3.736,-7.022 1.587,-1.946 3.664,-3.424 6.102,-4.353 3.175,-1.21 6.628,-2.281 10.259,-3.072 51.071,-11.243 117.977,-36.234 119.338,-93.857 C 364.03,-312.643 309.71,-416.494 220.044,-463.622 185.891,-481.558 148.197,-491 109.533,-491 c -38.686,0 -76.434,9.442 -110.645,27.51 -89.533,47.092 -141.587,143.563 -141.587,243.569 0,57.359 68.188,82.184 118.467,93.484 5.598,1.249 10.762,3.238 15.108,5.499 2.004,1.043 4.013,2.031 5.995,3 4.53,2.217 8.164,6.291 9.965,11.619 1.517,4.513 3.026,9.028 4.367,13.567 0.96,3.264 1.803,6.511 2.51,9.765 1.705,7.849 2.045,15.062 1.308,22.997 -0.091,0.98 -0.202,1.97 -0.321,2.97 C 12.435,-38.017 6.138,-18.059 0,0"
                            style={{
                              fill: "#eaeaea",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path440"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g460">
                  <g id="g450" />
                  <g id="g458">
                    <g clipPath="url(#clipPath96)" id="g456">
                      <g
                        className="layer-container"
                        transform="translate(316.0137,638.9951)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.67,16.622 -1.592,34.897 10.136,47.535 2.057,2.219 4.337,4.248 6.819,6.06 5.158,3.789 11.02,6.47 17.197,7.907 4.604,1.07 9.35,1.448 14.077,1.102 2.844,-0.208 5.652,-0.685 8.396,-1.4 5.815,-1.515 11.458,-3.933 16.689,-7.162 13.346,-8.236 26.178,-17.474 38.457,-26.995 26.395,-20.477 51.565,-43.721 72.173,-70.038 16.161,-20.581 29.941,-43.83 37.705,-68.954 0.828,-2.679 2.106,-5.044 3.692,-7.034 1.563,-1.961 3.617,-3.459 6.034,-4.412 3.153,-1.242 6.596,-2.332 10.227,-3.121 50.941,-11.163 117.987,-36.046 119.441,-93.542 2.331,-92.077 -52.043,-196.283 -141.575,-243.339 -34.096,-17.905 -71.725,-27.332 -110.322,-27.332 -38.62,0 -76.302,9.427 -110.454,27.463 -89.4,47.023 -141.368,143.355 -141.368,243.208 0,57.335 68.689,82.023 118.782,93.212 5.605,1.243 10.752,3.282 15.038,5.625 1.971,1.078 3.95,2.101 5.904,3.106 4.461,2.294 8.053,6.393 9.853,11.721 1.516,4.517 3.023,9.036 4.359,13.577 0.959,3.269 1.797,6.519 2.497,9.774 1.689,7.849 2.021,15.07 1.28,23.014 -0.093,0.981 -0.204,1.971 -0.324,2.972 C 12.442,-38.038 6.14,-18.067 0,0"
                            style={{
                              fill: "#e9e8e9",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path452"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g472">
                  <g id="g462" />
                  <g id="g470">
                    <g clipPath="url(#clipPath100)" id="g468">
                      <g
                        className="layer-container"
                        transform="translate(316.4009,639.1269)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.635,16.518 -1.558,34.682 10.134,47.211 2.051,2.199 4.322,4.21 6.793,6.001 5.136,3.747 10.97,6.39 17.115,7.791 4.579,1.043 9.296,1.395 13.988,1.028 2.823,-0.221 5.61,-0.711 8.331,-1.436 5.766,-1.536 11.366,-3.953 16.562,-7.165 13.258,-8.194 26.013,-17.378 38.211,-26.838 26.365,-20.454 51.516,-43.679 72.101,-69.968 16.146,-20.561 29.915,-43.792 37.659,-68.895 0.825,-2.674 2.087,-5.043 3.648,-7.048 1.537,-1.977 3.571,-3.494 5.967,-4.469 3.131,-1.275 6.564,-2.385 10.194,-3.168 50.812,-11.085 117.996,-35.86 119.545,-93.23 2.469,-91.433 -51.96,-195.993 -141.356,-242.977 -34.039,-17.875 -71.603,-27.284 -110.133,-27.284 -38.555,0 -76.17,9.409 -110.263,27.414 -89.267,46.953 -141.151,143.146 -141.151,242.847 0,57.311 69.192,81.863 119.099,92.94 5.611,1.237 10.741,3.327 14.967,5.751 1.939,1.112 3.889,2.17 5.815,3.21 4.391,2.37 7.941,6.498 9.739,11.826 1.515,4.52 3.021,9.042 4.353,13.587 0.956,3.273 1.789,6.526 2.484,9.783 1.673,7.846 1.994,15.077 1.249,23.029 -0.093,0.983 -0.204,1.973 -0.324,2.975 C 12.449,-38.06 6.142,-18.075 0,0"
                            style={{
                              fill: "#e7e7e7",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path464"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g484">
                  <g id="g474" />
                  <g id="g482">
                    <g clipPath="url(#clipPath104)" id="g480">
                      <g
                        className="layer-container"
                        transform="translate(316.7876,639.2587)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.6,16.413 -1.524,34.465 10.133,46.887 2.044,2.179 4.306,4.171 6.766,5.941 5.116,3.706 10.921,6.31 17.033,7.675 4.555,1.017 9.241,1.345 13.899,0.956 2.802,-0.235 5.567,-0.737 8.267,-1.473 5.716,-1.556 11.272,-3.974 16.435,-7.17 13.17,-8.15 25.846,-17.282 37.963,-26.678 26.337,-20.433 51.47,-43.636 72.031,-69.898 16.131,-20.54 29.891,-43.754 37.613,-68.838 0.821,-2.669 2.068,-5.042 3.602,-7.06 1.514,-1.992 3.526,-3.529 5.901,-4.529 3.108,-1.308 6.533,-2.435 10.162,-3.214 50.682,-11.006 118.005,-35.673 119.648,-92.916 2.607,-90.79 -51.876,-195.704 -141.138,-242.615 -33.981,-17.844 -71.479,-27.238 -109.942,-27.238 -38.49,0 -76.039,9.394 -110.073,27.365 -89.133,46.885 -140.933,142.939 -140.933,242.488 0,57.286 69.695,81.701 119.415,92.667 5.618,1.23 10.73,3.371 14.896,5.878 1.907,1.147 3.828,2.24 5.726,3.315 4.321,2.446 7.829,6.602 9.625,11.928 1.516,4.523 3.019,9.05 4.347,13.597 0.954,3.279 1.782,6.535 2.471,9.793 1.656,7.845 1.969,15.084 1.219,23.045 -0.093,0.983 -0.205,1.974 -0.325,2.976 C 12.455,-38.081 6.145,-18.084 0,0"
                            style={{
                              fill: "#e6e6e6",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path476"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g496">
                  <g id="g486" />
                  <g id="g494">
                    <g clipPath="url(#clipPath108)" id="g492">
                      <g
                        className="layer-container"
                        transform="translate(317.1743,639.3915)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.565,16.308 -1.49,34.248 10.131,46.563 2.038,2.16 4.292,4.13 6.742,5.881 5.092,3.664 10.871,6.229 16.949,7.558 4.53,0.99 9.187,1.293 13.81,0.882 2.782,-0.247 5.525,-0.762 8.202,-1.507 5.668,-1.577 11.18,-3.995 16.309,-7.174 13.082,-8.106 25.68,-17.187 37.715,-26.521 26.309,-20.411 51.423,-43.594 71.961,-69.827 16.117,-20.52 29.868,-43.715 37.567,-68.781 0.817,-2.665 2.049,-5.042 3.557,-7.074 1.489,-2.007 3.478,-3.563 5.832,-4.586 3.086,-1.341 6.502,-2.486 10.131,-3.262 50.553,-10.926 118.013,-35.486 119.751,-92.602 2.745,-90.147 -51.791,-195.413 -140.918,-242.253 -33.925,-17.815 -71.357,-27.192 -109.753,-27.192 -38.424,0 -75.906,9.377 -109.882,27.319 -89,46.815 -140.715,142.73 -140.715,242.126 0,57.262 70.197,81.541 119.731,92.393 5.625,1.225 10.72,3.416 14.825,6.005 1.875,1.183 3.766,2.311 5.637,3.421 4.251,2.524 7.717,6.705 9.512,12.031 1.515,4.527 3.016,9.057 4.34,13.608 0.952,3.283 1.775,6.542 2.457,9.803 1.641,7.842 1.944,15.091 1.191,23.06 -0.094,0.983 -0.207,1.975 -0.327,2.978 C 12.463,-38.103 6.147,-18.094 0,0"
                            style={{
                              fill: "#e5e4e5",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path488"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g508">
                  <g id="g498" />
                  <g id="g506">
                    <g clipPath="url(#clipPath112)" id="g504">
                      <g
                        className="layer-container"
                        transform="translate(317.561,639.5224)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.53,16.204 -1.456,34.033 10.129,46.238 2.032,2.142 4.278,4.094 6.716,5.825 5.072,3.622 10.822,6.147 16.867,7.44 4.506,0.964 9.133,1.241 13.722,0.809 2.76,-0.261 5.482,-0.788 8.136,-1.542 5.619,-1.599 11.088,-4.017 16.183,-7.178 12.994,-8.064 25.514,-17.093 37.469,-26.363 26.279,-20.39 51.374,-43.553 71.889,-69.756 16.101,-20.5 29.842,-43.679 37.52,-68.724 0.815,-2.66 2.031,-5.041 3.514,-7.087 1.464,-2.022 3.43,-3.598 5.764,-4.644 3.065,-1.374 6.471,-2.538 10.099,-3.309 50.424,-10.849 118.019,-35.301 119.854,-92.29 2.881,-89.503 -51.707,-195.123 -140.699,-241.89 -33.867,-17.785 -71.234,-27.146 -109.564,-27.146 -38.359,0 -75.774,9.361 -109.691,27.271 -88.866,46.745 -140.497,142.522 -140.497,241.765 0,57.238 70.699,81.38 120.047,92.122 5.632,1.218 10.709,3.46 14.755,6.131 1.843,1.217 3.704,2.38 5.547,3.524 4.182,2.599 7.606,6.81 9.398,12.135 1.516,4.53 3.014,9.065 4.334,13.618 0.949,3.289 1.775,6.549 2.444,9.813 1.64,7.838 1.918,15.098 1.161,23.076 -0.095,0.984 -0.207,1.976 -0.328,2.979 C 12.464,-38.123 6.149,-18.102 0,0"
                            style={{
                              fill: "#e3e3e3",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path500"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g520">
                  <g id="g510" />
                  <g id="g518">
                    <g clipPath="url(#clipPath116)" id="g516">
                      <g
                        className="layer-container"
                        transform="translate(317.9482,639.6552)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.496,16.099 -1.421,33.816 10.127,45.914 2.026,2.122 4.263,4.053 6.691,5.764 5.049,3.581 10.772,6.067 16.784,7.324 4.481,0.936 9.078,1.189 13.632,0.736 2.741,-0.273 5.44,-0.814 8.072,-1.58 5.569,-1.621 10.995,-4.035 16.056,-7.179 12.907,-8.021 25.348,-16.999 37.221,-26.207 26.251,-20.367 51.328,-43.508 71.82,-69.684 16.085,-20.481 29.82,-43.641 37.472,-68.666 0.813,-2.656 2.013,-5.04 3.469,-7.101 1.441,-2.037 3.385,-3.632 5.698,-4.702 3.042,-1.408 6.44,-2.59 10.066,-3.357 50.295,-10.77 118.028,-35.114 119.958,-91.976 3.017,-88.86 -51.622,-194.833 -140.48,-241.528 -33.809,-17.754 -71.111,-27.099 -109.374,-27.099 -38.294,0 -75.642,9.345 -109.501,27.224 -88.732,46.676 -140.279,142.312 -140.279,241.403 0,57.214 71.202,81.22 120.364,91.849 5.638,1.213 10.699,3.504 14.683,6.258 1.812,1.252 3.644,2.45 5.458,3.63 4.112,2.675 7.494,6.914 9.285,12.239 1.516,4.533 3.012,9.07 4.328,13.627 0.947,3.294 1.761,6.557 2.43,9.822 1.608,7.839 1.894,15.105 1.131,23.092 -0.094,0.984 -0.207,1.977 -0.329,2.98 C 12.472,-38.145 6.152,-18.11 0,0"
                            style={{
                              fill: "#e2e1e2",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path512"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g532">
                  <g id="g522" />
                  <g id="g530">
                    <g clipPath="url(#clipPath120)" id="g528">
                      <g
                        className="layer-container"
                        transform="translate(318.335,639.788)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.46,15.993 -1.387,33.599 10.126,45.588 2.019,2.103 4.248,4.016 6.665,5.706 5.027,3.539 10.722,5.986 16.701,7.208 4.456,0.909 9.023,1.137 13.544,0.662 2.719,-0.287 5.397,-0.84 8.006,-1.615 5.521,-1.642 10.903,-4.056 15.93,-7.184 12.819,-7.977 25.182,-16.903 36.974,-26.049 26.222,-20.344 51.279,-43.466 71.748,-69.613 16.071,-20.461 29.795,-43.604 37.428,-68.609 0.808,-2.651 1.994,-5.04 3.423,-7.114 1.416,-2.053 3.338,-3.667 5.63,-4.76 3.021,-1.441 6.408,-2.641 10.034,-3.404 50.166,-10.691 118.035,-34.926 120.062,-91.663 3.151,-88.216 -51.538,-194.543 -140.26,-241.165 -33.753,-17.724 -70.99,-27.052 -109.186,-27.052 -38.228,0 -75.51,9.328 -109.31,27.174 -88.599,46.607 -140.061,142.105 -140.061,241.043 0,57.191 71.705,81.059 120.68,91.576 5.645,1.207 10.688,3.547 14.613,6.384 1.778,1.286 3.582,2.52 5.369,3.736 4.042,2.75 7.382,7.017 9.17,12.341 1.516,4.539 3.01,9.079 4.322,13.638 0.944,3.299 1.76,6.565 2.417,9.831 1.607,7.835 1.868,15.112 1.101,23.109 -0.095,0.984 -0.208,1.978 -0.33,2.982 C 12.477,-38.167 6.154,-18.12 0,0"
                            style={{
                              fill: "#e0e0e0",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path524"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g544">
                  <g id="g534" />
                  <g id="g542">
                    <g clipPath="url(#clipPath124)" id="g540">
                      <g
                        className="layer-container"
                        transform="translate(318.7217,639.9189)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.425,15.89 -1.353,33.384 10.125,45.266 2.012,2.084 4.232,3.975 6.638,5.646 5.006,3.497 10.673,5.905 16.618,7.091 4.432,0.883 8.97,1.085 13.455,0.589 2.7,-0.301 5.355,-0.864 7.943,-1.651 5.471,-1.663 10.81,-4.077 15.803,-7.188 12.73,-7.934 25.016,-16.808 36.727,-25.89 26.193,-20.324 51.232,-43.425 71.677,-69.543 16.056,-20.44 29.771,-43.566 37.381,-68.55 0.806,-2.647 1.975,-5.041 3.38,-7.128 1.391,-2.069 3.291,-3.703 5.562,-4.82 2.997,-1.474 6.377,-2.691 10.002,-3.45 50.035,-10.612 118.04,-34.739 120.164,-91.35 3.286,-87.572 -51.453,-194.252 -140.04,-240.803 -33.696,-17.694 -70.867,-27.006 -108.997,-27.006 -38.162,0 -75.377,9.312 -109.119,27.127 -88.465,46.537 -139.843,141.896 -139.843,240.682 0,57.166 72.207,80.898 120.996,91.304 5.652,1.199 10.679,3.59 14.542,6.51 1.747,1.321 3.521,2.59 5.279,3.841 3.973,2.825 7.271,7.122 9.058,12.444 1.515,4.541 3.007,9.086 4.315,13.65 0.942,3.303 1.752,6.571 2.404,9.839 1.591,7.833 1.842,15.12 1.072,23.124 -0.097,0.987 -0.21,1.981 -0.332,2.984 C 12.484,-38.188 6.157,-18.127 0,0"
                            style={{
                              fill: "#dfdfdf",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path536"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g556">
                  <g id="g546" />
                  <g id="g554">
                    <g clipPath="url(#clipPath128)" id="g552">
                      <g
                        className="layer-container"
                        transform="translate(319.1089,640.0517)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.391,15.785 -1.319,33.166 10.122,44.939 2.006,2.066 4.218,3.938 6.613,5.588 4.985,3.456 10.624,5.825 16.536,6.975 4.407,0.855 8.915,1.033 13.366,0.515 2.679,-0.313 5.313,-0.889 7.878,-1.685 5.423,-1.683 10.717,-4.098 15.675,-7.192 12.644,-7.891 24.851,-16.713 36.481,-25.733 26.165,-20.302 51.183,-43.382 71.606,-69.471 16.041,-20.421 29.748,-43.529 37.335,-68.495 0.803,-2.642 1.955,-5.038 3.334,-7.14 1.367,-2.085 3.245,-3.737 5.496,-4.877 2.976,-1.508 6.346,-2.742 9.97,-3.498 49.906,-10.533 118.047,-34.554 120.268,-91.036 3.419,-86.929 -51.369,-193.962 -139.822,-240.441 -33.638,-17.665 -70.744,-26.961 -108.807,-26.961 -38.097,0 -75.245,9.296 -108.928,27.08 -88.332,46.468 -139.626,141.689 -139.626,240.322 0,57.141 72.71,80.737 121.313,91.031 5.658,1.193 10.669,3.632 14.471,6.636 1.716,1.355 3.459,2.659 5.19,3.945 3.903,2.901 7.159,7.227 8.943,12.549 1.516,4.545 3.006,9.093 4.31,13.658 0.94,3.31 1.745,6.58 2.39,9.85 1.574,7.832 1.817,15.128 1.042,23.14 -0.096,0.987 -0.21,1.981 -0.333,2.985 C 12.486,-38.21 6.159,-18.137 0,0"
                            style={{
                              fill: "#deddde",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path548"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g568">
                  <g id="g558" />
                  <g id="g566">
                    <g clipPath="url(#clipPath132)" id="g564">
                      <g
                        className="layer-container"
                        transform="translate(319.4956,640.1835)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.355,15.681 -1.285,32.95 10.121,44.616 1.999,2.045 4.203,3.899 6.587,5.529 4.963,3.414 10.574,5.743 16.453,6.857 4.382,0.829 8.86,0.981 13.277,0.442 2.659,-0.326 5.271,-0.914 7.813,-1.72 5.374,-1.704 10.625,-4.12 15.549,-7.198 12.555,-7.847 24.684,-16.617 36.234,-25.574 26.136,-20.279 51.136,-43.34 71.535,-69.4 16.026,-20.401 29.723,-43.491 37.288,-68.437 0.8,-2.637 1.938,-5.038 3.29,-7.153 1.343,-2.101 3.198,-3.773 5.429,-4.937 2.952,-1.54 6.314,-2.794 9.937,-3.544 49.777,-10.455 118.052,-34.367 120.372,-90.723 3.551,-86.284 -51.285,-193.673 -139.603,-240.078 -33.582,-17.635 -70.622,-26.914 -108.617,-26.914 -38.032,0 -75.114,9.279 -108.738,27.032 -88.199,46.398 -139.407,141.479 -139.407,239.96 0,57.118 73.211,80.577 121.628,90.759 5.665,1.186 10.659,3.675 14.4,6.762 1.683,1.389 3.398,2.729 5.101,4.051 3.833,2.976 7.047,7.329 8.83,12.651 1.515,4.548 3.003,9.1 4.302,13.669 0.938,3.314 1.739,6.587 2.378,9.859 1.558,7.83 1.791,15.135 1.013,23.156 -0.098,0.986 -0.212,1.982 -0.335,2.986 C 12.495,-38.231 6.161,-18.146 0,0"
                            style={{
                              fill: "#dcdcdc",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path560"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g580">
                  <g id="g570" />
                  <g id="g578">
                    <g clipPath="url(#clipPath136)" id="g576">
                      <g
                        className="layer-container"
                        transform="translate(319.8823,640.3154)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.32,15.576 -1.251,32.734 10.119,44.291 1.993,2.027 4.189,3.859 6.562,5.471 4.941,3.372 10.524,5.662 16.37,6.74 4.357,0.803 8.806,0.931 13.189,0.369 2.637,-0.34 5.227,-0.94 7.747,-1.757 5.325,-1.725 10.533,-4.138 15.423,-7.2 12.467,-7.804 24.519,-16.522 35.986,-25.416 26.108,-20.258 51.089,-43.299 71.465,-69.33 16.011,-20.381 29.701,-43.453 37.242,-68.379 0.797,-2.635 1.918,-5.039 3.246,-7.168 1.317,-2.115 3.15,-3.807 5.361,-4.994 2.93,-1.574 6.282,-2.845 9.905,-3.591 49.647,-10.376 118.056,-34.181 120.475,-90.41 3.681,-85.642 -51.201,-193.382 -139.384,-239.716 -33.524,-17.605 -70.499,-26.868 -108.428,-26.868 -37.966,0 -74.982,9.263 -108.548,26.985 -88.064,46.328 -139.189,141.272 -139.189,239.599 0,57.095 73.715,80.416 121.945,90.486 5.672,1.181 10.649,3.719 14.329,6.889 1.652,1.423 3.337,2.798 5.012,4.155 3.764,3.051 6.935,7.434 8.716,12.755 1.516,4.552 3.001,9.108 4.297,13.68 0.935,3.319 1.731,6.595 2.364,9.868 1.541,7.828 1.766,15.143 0.983,23.172 -0.098,0.988 -0.212,1.983 -0.336,2.988 C 12.5,-38.253 6.164,-18.154 0,0"
                            style={{
                              fill: "#dbdadb",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path572"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g592">
                  <g id="g582" />
                  <g id="g590">
                    <g clipPath="url(#clipPath140)" id="g588">
                      <g
                        className="layer-container"
                        transform="translate(320.269,640.4482)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.285,15.471 -1.217,32.518 10.118,43.967 1.986,2.008 4.173,3.82 6.536,5.41 4.919,3.331 10.474,5.582 16.287,6.625 4.333,0.775 8.752,0.878 13.1,0.295 2.617,-0.353 5.185,-0.965 7.683,-1.792 5.275,-1.746 10.44,-4.16 15.296,-7.204 12.379,-7.761 24.352,-16.428 35.739,-25.258 26.079,-20.236 51.041,-43.256 71.394,-69.26 15.995,-20.361 29.675,-43.416 37.196,-68.322 0.794,-2.629 1.899,-5.037 3.2,-7.18 1.294,-2.132 3.105,-3.843 5.294,-5.052 2.908,-1.608 6.252,-2.897 9.873,-3.639 49.518,-10.297 118.061,-33.993 120.578,-90.097 3.813,-84.998 -51.116,-193.092 -139.164,-239.353 -33.467,-17.576 -70.376,-26.822 -108.239,-26.822 -37.901,0 -74.849,9.246 -108.356,26.937 -87.932,46.259 -138.972,141.063 -138.972,239.238 0,57.07 74.217,80.256 122.261,90.214 5.679,1.174 10.639,3.761 14.259,7.016 1.62,1.457 3.275,2.866 4.922,4.259 3.694,3.126 6.824,7.539 8.602,12.858 1.516,4.556 2.999,9.115 4.29,13.691 0.934,3.323 1.725,6.602 2.351,9.877 1.525,7.826 1.741,15.149 0.954,23.188 -0.098,0.988 -0.213,1.984 -0.337,2.99 C 12.507,-38.274 6.166,-18.163 0,0"
                            style={{
                              fill: "#d9d9d9",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path584"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g604">
                  <g id="g594" />
                  <g id="g602">
                    <g clipPath="url(#clipPath144)" id="g600">
                      <g
                        className="layer-container"
                        transform="translate(320.6558,640.58)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.25,15.366 -1.183,32.302 10.116,43.642 1.98,1.989 4.159,3.782 6.511,5.353 4.897,3.288 10.425,5.5 16.205,6.506 4.307,0.75 8.696,0.827 13.01,0.223 2.596,-0.366 5.142,-0.991 7.618,-1.828 5.226,-1.768 10.348,-4.18 15.17,-7.208 12.292,-7.717 24.186,-16.332 35.492,-25.1 26.05,-20.215 50.992,-43.214 71.323,-69.189 15.981,-20.34 29.653,-43.377 37.149,-68.263 0.791,-2.626 1.881,-5.038 3.156,-7.195 1.269,-2.147 3.058,-3.877 5.227,-5.11 2.885,-1.642 6.219,-2.948 9.84,-3.686 49.389,-10.218 118.065,-33.807 120.681,-89.784 3.943,-84.354 -51.031,-192.801 -138.944,-238.991 -33.41,-17.545 -70.254,-26.775 -108.05,-26.775 -37.835,0 -74.717,9.23 -108.165,26.889 -87.799,46.19 -138.754,140.855 -138.754,238.877 0,57.046 74.72,80.095 122.577,89.941 5.686,1.168 10.63,3.803 14.188,7.142 1.588,1.492 3.214,2.937 4.833,4.366 3.626,3.2 6.712,7.642 8.489,12.961 1.515,4.558 2.996,9.122 4.284,13.701 0.931,3.328 1.717,6.609 2.337,9.886 1.509,7.825 1.715,15.157 0.924,23.204 -0.099,0.988 -0.214,1.986 -0.338,2.991 C 12.512,-38.295 6.169,-18.171 0,0"
                            style={{
                              fill: "#d8d8d8",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path596"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g616">
                  <g id="g606" />
                  <g id="g614">
                    <g clipPath="url(#clipPath148)" id="g612">
                      <g
                        className="layer-container"
                        transform="translate(321.0425,640.7119)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.215,15.262 -1.148,32.085 10.114,43.318 1.974,1.969 4.145,3.743 6.486,5.293 4.875,3.246 10.375,5.42 16.122,6.391 4.282,0.722 8.642,0.775 12.921,0.148 2.576,-0.378 5.1,-1.015 7.553,-1.863 5.177,-1.788 10.256,-4.2 15.043,-7.211 12.204,-7.674 24.021,-16.237 35.245,-24.943 26.022,-20.194 50.946,-43.172 71.252,-69.117 15.966,-20.321 29.628,-43.34 37.104,-68.207 0.787,-2.622 1.861,-5.038 3.11,-7.207 1.245,-2.163 3.011,-3.913 5.16,-5.17 2.863,-1.675 6.189,-2.998 9.809,-3.733 49.259,-10.138 118.067,-33.62 120.784,-89.47 4.072,-83.711 -50.947,-192.51 -138.725,-238.628 -33.353,-17.515 -70.131,-26.73 -107.86,-26.73 -37.771,0 -74.585,9.215 -107.975,26.842 -87.665,46.121 -138.536,140.646 -138.536,238.516 0,57.022 75.222,79.935 122.893,89.669 5.692,1.162 10.621,3.844 14.117,7.268 1.557,1.524 3.153,3.006 4.744,4.471 3.556,3.275 6.6,7.746 8.375,13.064 1.515,4.563 2.994,9.129 4.278,13.711 0.928,3.334 1.71,6.617 2.324,9.896 1.493,7.824 1.69,15.163 0.894,23.219 -0.099,0.99 -0.214,1.988 -0.339,2.993 C 12.519,-38.317 6.171,-18.18 0,0"
                            style={{
                              fill: "#d7d6d7",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path608"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g628">
                  <g id="g618" />
                  <g id="g626">
                    <g clipPath="url(#clipPath152)" id="g624">
                      <g
                        className="layer-container"
                        transform="translate(321.4297,640.8447)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.181,15.156 -1.115,31.868 10.113,42.992 1.967,1.951 4.129,3.704 6.459,5.236 4.853,3.204 10.325,5.338 16.039,6.272 4.258,0.696 8.588,0.725 12.833,0.076 2.555,-0.39 5.058,-1.041 7.488,-1.898 5.129,-1.809 10.163,-4.222 14.917,-7.215 12.116,-7.631 23.854,-16.143 34.998,-24.785 25.992,-20.172 50.897,-43.129 71.181,-69.047 15.95,-20.301 29.602,-43.303 37.056,-68.15 0.786,-2.616 1.843,-5.036 3.067,-7.219 1.221,-2.178 2.965,-3.95 5.093,-5.229 2.84,-1.708 6.157,-3.05 9.775,-3.779 49.131,-10.061 118.07,-33.435 120.888,-89.157 4.2,-83.069 -50.863,-192.222 -138.506,-238.267 -33.295,-17.484 -70.008,-26.683 -107.671,-26.683 -37.704,0 -74.452,9.199 -107.784,26.794 -87.531,46.051 -138.318,140.438 -138.318,238.156 0,56.997 75.725,79.773 123.21,89.395 5.699,1.156 10.612,3.887 14.046,7.395 1.526,1.558 3.092,3.075 4.655,4.576 3.486,3.349 6.488,7.849 8.261,13.168 1.515,4.565 2.992,9.136 4.271,13.721 0.927,3.337 1.703,6.625 2.311,9.905 1.476,7.821 1.664,15.171 0.865,23.234 -0.1,0.991 -0.216,1.989 -0.341,2.995 C 12.525,-38.339 6.173,-18.189 0,0"
                            style={{
                              fill: "#d5d5d5",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path620"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g640">
                  <g id="g630" />
                  <g id="g638">
                    <g clipPath="url(#clipPath156)" id="g636">
                      <g
                        className="layer-container"
                        transform="translate(321.8164,640.9765)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.146,15.052 -1.081,31.651 10.111,42.669 1.961,1.932 4.114,3.664 6.433,5.176 4.832,3.163 10.277,5.258 15.957,6.156 4.234,0.669 8.534,0.672 12.744,0.002 2.535,-0.404 5.016,-1.066 7.423,-1.934 5.08,-1.83 10.071,-4.242 14.79,-7.218 12.03,-7.587 23.689,-16.048 34.751,-24.627 25.965,-20.151 50.85,-43.088 71.111,-68.977 15.935,-20.281 29.581,-43.265 37.011,-68.092 0.781,-2.613 1.823,-5.036 3.021,-7.234 1.195,-2.193 2.918,-3.983 5.024,-5.285 2.819,-1.742 6.126,-3.102 9.745,-3.828 49.001,-9.981 118.072,-33.246 120.991,-88.843 4.327,-82.425 -50.779,-191.932 -138.287,-237.904 -33.239,-17.455 -69.886,-26.636 -107.481,-26.636 -37.64,0 -74.321,9.181 -107.594,26.746 -87.398,45.98 -138.1,140.228 -138.1,237.794 0,56.973 76.227,79.612 123.526,89.124 5.705,1.148 10.603,3.927 13.975,7.519 1.495,1.593 3.031,3.145 4.565,4.682 3.418,3.424 6.377,7.953 8.148,13.271 1.515,4.569 2.99,9.143 4.265,13.731 0.924,3.344 1.696,6.633 2.298,9.915 1.46,7.819 1.639,15.178 0.835,23.251 -0.1,0.99 -0.215,1.99 -0.342,2.996 C 12.568,-38.356 6.176,-18.197 0,0"
                            style={{
                              fill: "#d4d3d4",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path632"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g652">
                  <g id="g642" />
                  <g id="g650">
                    <g clipPath="url(#clipPath160)" id="g648">
                      <g
                        className="layer-container"
                        transform="translate(322.2036,641.1083)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.111,14.947 -1.047,31.436 10.109,42.344 1.954,1.913 4.099,3.627 6.408,5.117 4.81,3.122 10.226,5.178 15.874,6.041 4.209,0.641 8.479,0.619 12.655,-0.072 2.514,-0.417 4.973,-1.092 7.358,-1.97 5.03,-1.852 9.979,-4.263 14.664,-7.223 11.94,-7.544 23.522,-15.952 34.503,-24.468 25.937,-20.128 50.803,-43.046 71.04,-68.906 15.921,-20.26 29.557,-43.226 36.964,-68.034 0.779,-2.608 1.805,-5.036 2.977,-7.247 1.172,-2.209 2.871,-4.019 4.958,-5.345 2.796,-1.775 6.094,-3.153 9.712,-3.874 48.872,-9.902 118.074,-33.061 121.094,-88.53 4.454,-81.781 -50.694,-191.642 -138.067,-237.542 -33.182,-17.425 -69.764,-26.59 -107.292,-26.59 -37.575,0 -74.189,9.165 -107.403,26.699 -87.265,45.912 -137.882,140.021 -137.882,237.433 0,56.95 76.729,79.452 123.842,88.851 5.712,1.142 10.595,3.968 13.904,7.646 1.464,1.627 2.97,3.215 4.476,4.787 3.349,3.497 6.265,8.058 8.034,13.374 1.515,4.573 2.988,9.151 4.259,13.741 0.922,3.349 1.688,6.641 2.284,9.924 1.444,7.82 1.614,15.186 0.805,23.267 -0.1,0.992 -0.214,1.991 -0.342,2.999 C 12.572,-38.377 6.178,-18.206 0,0"
                            style={{
                              fill: "#d2d2d2",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path644"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g664">
                  <g id="g654" />
                  <g id="g662">
                    <g clipPath="url(#clipPath164)" id="g660">
                      <g
                        className="layer-container"
                        transform="translate(322.5903,641.2411)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.076,14.842 -1.013,31.219 10.107,42.02 1.949,1.892 4.085,3.586 6.383,5.058 4.788,3.079 10.177,5.096 15.791,5.922 4.184,0.615 8.425,0.568 12.566,-0.145 2.493,-0.429 4.93,-1.117 7.294,-2.005 4.98,-1.872 9.885,-4.284 14.537,-7.226 11.853,-7.5 23.356,-15.857 34.256,-24.312 25.908,-20.105 50.754,-43.001 70.968,-68.833 15.907,-20.242 29.585,-43.174 36.918,-67.977 0.782,-2.604 1.785,-5.035 2.933,-7.262 1.145,-2.223 2.824,-4.053 4.891,-5.402 2.772,-1.81 6.063,-3.203 9.679,-3.921 48.742,-9.823 118.074,-32.874 121.198,-88.217 4.579,-81.137 -50.61,-191.35 -137.848,-237.179 -33.124,-17.395 -69.641,-26.544 -107.103,-26.544 -37.509,0 -74.056,9.149 -107.213,26.651 -87.13,45.843 -137.664,139.813 -137.664,237.072 0,56.926 77.233,79.292 124.159,88.577 5.719,1.138 10.587,4.011 13.834,7.774 1.432,1.66 2.908,3.284 4.386,4.892 3.28,3.572 6.154,8.161 7.92,13.477 1.516,4.576 2.987,9.158 4.253,13.752 0.92,3.353 1.681,6.649 2.271,9.933 1.427,7.818 1.588,15.193 0.776,23.283 -0.102,0.993 -0.217,1.993 -0.345,3 C 12.577,-38.399 6.18,-18.215 0,0"
                            style={{
                              fill: "#d1d0d1",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path656"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g676">
                  <g id="g666" />
                  <g id="g674">
                    <g clipPath="url(#clipPath168)" id="g672">
                      <g
                        className="layer-container"
                        transform="translate(322.9771,641.372)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.041,14.738 -0.979,31.004 10.105,41.695 1.942,1.875 4.071,3.549 6.357,5 4.767,3.038 10.128,5.016 15.709,5.807 4.159,0.588 8.37,0.516 12.477,-0.219 2.473,-0.443 4.888,-1.141 7.229,-2.041 4.931,-1.893 9.793,-4.304 14.41,-7.23 11.765,-7.458 23.191,-15.762 34.01,-24.153 25.879,-20.085 50.707,-42.961 70.898,-68.763 15.89,-20.221 29.558,-43.137 36.871,-67.92 0.778,-2.598 1.767,-5.033 2.888,-7.274 1.121,-2.24 2.776,-4.089 4.823,-5.461 2.75,-1.843 6.033,-3.254 9.647,-3.968 48.613,-9.744 118.075,-32.688 121.302,-87.904 4.703,-80.494 -50.526,-191.061 -137.629,-236.817 -33.068,-17.365 -69.519,-26.497 -106.914,-26.497 -37.443,0 -73.924,9.132 -107.021,26.603 -86.998,45.773 -137.446,139.605 -137.446,236.711 0,56.902 77.734,79.131 124.474,88.306 5.726,1.13 10.578,4.052 13.763,7.899 1.401,1.693 2.847,3.352 4.297,4.997 3.211,3.646 6.042,8.266 7.807,13.581 1.515,4.58 2.984,9.165 4.246,13.761 0.917,3.36 1.674,6.658 2.258,9.944 1.411,7.815 1.563,15.199 0.746,23.297 -0.102,0.994 -0.217,1.995 -0.346,3.001 C 12.581,-38.42 6.183,-18.223 0,0"
                            style={{
                              fill: "#d0cfd0",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path668"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g688">
                  <g id="g678" />
                  <g id="g686">
                    <g clipPath="url(#clipPath172)" id="g684">
                      <g
                        className="layer-container"
                        transform="translate(323.3638,641.5048)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -5.006,14.633 -0.944,30.787 10.104,41.371 1.936,1.855 4.055,3.51 6.332,4.94 4.744,2.997 10.077,4.935 15.625,5.689 4.134,0.563 8.316,0.465 12.388,-0.291 2.452,-0.457 4.845,-1.167 7.164,-2.076 4.882,-1.915 9.701,-4.324 14.284,-7.235 11.677,-7.414 23.024,-15.667 33.762,-23.995 25.851,-20.062 50.659,-42.919 70.827,-68.692 15.876,-20.201 29.534,-43.101 36.826,-67.862 0.774,-2.593 1.747,-5.036 2.842,-7.287 1.098,-2.256 2.731,-4.124 4.756,-5.519 2.729,-1.877 6.001,-3.307 9.615,-4.016 48.484,-9.666 118.076,-32.502 121.405,-87.59 4.827,-79.852 -50.441,-190.771 -137.409,-236.456 -33.01,-17.335 -69.396,-26.45 -106.725,-26.45 -37.378,0 -73.792,9.115 -106.831,26.555 -86.863,45.703 -137.228,139.396 -137.228,236.351 0,56.877 78.238,78.969 124.791,88.032 5.733,1.125 10.57,4.094 13.692,8.027 1.37,1.726 2.787,3.421 4.208,5.102 3.143,3.718 5.93,8.369 7.693,13.683 1.516,4.584 2.982,9.172 4.24,13.773 0.915,3.363 1.667,6.664 2.244,9.952 1.395,7.813 1.538,15.206 0.717,23.313 -0.102,0.994 -0.218,1.995 -0.346,3.003 C 12.585,-38.442 6.186,-18.232 0,0"
                            style={{
                              fill: "#cecece",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path680"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g700">
                  <g id="g690" />
                  <g id="g698">
                    <g clipPath="url(#clipPath176)" id="g696">
                      <g
                        className="layer-container"
                        transform="translate(323.7505,641.6376)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.971,14.527 -0.91,30.569 10.103,41.045 1.928,1.837 4.04,3.472 6.305,4.883 4.723,2.954 10.028,4.853 15.543,5.572 4.11,0.535 8.261,0.412 12.299,-0.365 2.432,-0.47 4.804,-1.193 7.1,-2.112 4.833,-1.934 9.608,-4.345 14.157,-7.238 11.59,-7.37 22.858,-15.572 33.515,-23.838 25.822,-20.04 50.612,-42.875 70.756,-68.621 15.861,-20.181 29.507,-43.063 36.78,-67.805 0.77,-2.589 1.727,-5.034 2.797,-7.3 1.073,-2.272 2.684,-4.16 4.689,-5.577 2.705,-1.913 5.97,-3.358 9.583,-4.063 48.354,-9.587 118.073,-32.314 121.508,-87.277 4.949,-79.208 -50.357,-190.481 -137.191,-236.093 -32.952,-17.305 -69.272,-26.404 -106.534,-26.404 -37.313,0 -73.66,9.099 -106.64,26.507 -86.731,45.634 -137.011,139.188 -137.011,235.99 0,56.853 78.74,78.809 125.107,87.759 5.739,1.119 10.563,4.134 13.621,8.154 1.34,1.76 2.726,3.489 4.118,5.207 3.076,3.793 5.819,8.472 7.581,13.786 1.515,4.587 2.979,9.18 4.233,13.783 0.913,3.368 1.66,6.672 2.231,9.961 1.378,7.814 1.512,15.214 0.687,23.33 -0.103,0.995 -0.219,1.996 -0.348,3.005 C 12.59,-38.465 6.187,-18.242 0,0"
                            style={{
                              fill: "#cdcccd",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path692"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g712">
                  <g id="g702" />
                  <g id="g710">
                    <g clipPath="url(#clipPath180)" id="g708">
                      <g
                        className="layer-container"
                        transform="translate(324.1377,641.7685)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.936,14.424 -0.876,30.354 10.101,40.723 1.922,1.816 4.025,3.431 6.279,4.822 4.702,2.913 9.979,4.773 15.46,5.456 4.086,0.509 8.207,0.36 12.211,-0.438 2.411,-0.483 4.761,-1.218 7.034,-2.147 4.785,-1.955 9.517,-4.366 14.031,-7.242 11.502,-7.327 22.693,-15.477 33.268,-23.68 25.793,-20.019 50.564,-42.834 70.686,-68.551 15.846,-20.161 29.481,-43.026 36.732,-67.747 0.768,-2.585 1.709,-5.034 2.754,-7.313 1.048,-2.288 2.636,-4.196 4.621,-5.637 2.682,-1.945 5.939,-3.408 9.551,-4.109 48.225,-9.508 118.071,-32.128 121.611,-86.964 5.071,-78.566 -50.271,-190.191 -136.971,-235.73 -32.896,-17.275 -69.15,-26.359 -106.346,-26.359 -37.247,0 -73.527,9.084 -106.449,26.461 -86.597,45.564 -136.792,138.978 -136.792,235.628 0,56.829 79.242,78.648 125.423,87.487 5.746,1.111 10.555,4.176 13.55,8.279 1.309,1.793 2.665,3.56 4.029,5.313 3.008,3.867 5.707,8.577 7.467,13.89 1.514,4.59 2.976,9.186 4.227,13.794 0.91,3.373 1.652,6.679 2.217,9.969 1.362,7.812 1.487,15.222 0.658,23.346 -0.103,0.995 -0.22,1.997 -0.35,3.006 C 12.594,-38.485 6.19,-18.249 0,0"
                            style={{
                              fill: "#cbcbcb",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path704"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g724">
                  <g id="g714" />
                  <g id="g722">
                    <g clipPath="url(#clipPath184)" id="g720">
                      <g
                        className="layer-container"
                        transform="translate(324.5244,641.9013)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.901,14.318 -0.842,30.137 10.099,40.397 1.916,1.798 4.011,3.393 6.254,4.764 4.68,2.871 9.929,4.693 15.377,5.339 4.061,0.482 8.153,0.309 12.122,-0.512 2.391,-0.496 4.718,-1.243 6.97,-2.182 4.734,-1.977 9.424,-4.387 13.904,-7.246 11.414,-7.285 22.526,-15.382 33.021,-23.521 25.764,-19.998 50.516,-42.792 70.615,-68.48 15.83,-20.142 29.455,-42.99 36.686,-67.69 0.765,-2.581 1.69,-5.033 2.708,-7.328 1.023,-2.303 2.59,-4.23 4.555,-5.693 2.659,-1.98 5.906,-3.461 9.518,-4.158 48.095,-9.428 118.07,-31.942 121.714,-86.65 5.193,-77.923 -50.187,-189.9 -136.751,-235.368 -32.838,-17.244 -69.028,-26.312 -106.156,-26.312 -37.182,0 -73.396,9.068 -106.259,26.412 -86.463,45.496 -136.574,138.771 -136.574,235.268 0,56.806 79.744,78.487 125.739,87.215 5.752,1.105 10.548,4.217 13.479,8.405 1.279,1.827 2.605,3.628 3.94,5.418 2.939,3.941 5.595,8.681 7.353,13.992 1.515,4.595 2.975,9.195 4.221,13.804 0.908,3.379 1.645,6.688 2.204,9.98 1.345,7.81 1.462,15.228 0.628,23.362 -0.104,0.996 -0.221,1.998 -0.35,3.008 C 12.598,-38.508 6.192,-18.259 0,0"
                            style={{
                              fill: "#cac9ca",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path716"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g736">
                  <g id="g726" />
                  <g id="g734">
                    <g clipPath="url(#clipPath188)" id="g732">
                      <g
                        className="layer-container"
                        transform="translate(324.9116,642.0331)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.866,14.214 -0.809,29.921 10.097,40.073 1.91,1.779 3.996,3.354 6.229,4.705 4.657,2.829 9.879,4.612 15.294,5.222 4.036,0.455 8.098,0.258 12.033,-0.585 2.37,-0.508 4.675,-1.268 6.905,-2.218 4.685,-1.998 9.331,-4.407 13.777,-7.249 11.328,-7.239 22.36,-15.287 32.774,-23.365 25.736,-19.975 50.468,-42.748 70.543,-68.408 15.817,-20.121 29.43,-42.952 36.641,-67.633 0.762,-2.576 1.671,-5.032 2.664,-7.34 0.998,-2.319 2.542,-4.267 4.487,-5.753 2.636,-2.013 5.875,-3.511 9.486,-4.204 47.966,-9.349 118.066,-31.756 121.818,-86.337 5.312,-77.279 -50.103,-189.61 -136.533,-235.005 -32.78,-17.215 -68.904,-26.266 -105.966,-26.266 -37.117,0 -73.264,9.051 -106.068,26.365 -86.33,45.425 -136.357,138.562 -136.357,234.906 0,56.781 80.247,78.327 126.056,86.943 5.759,1.099 10.541,4.256 13.408,8.531 1.248,1.86 2.545,3.697 3.851,5.522 2.872,4.014 5.483,8.786 7.238,14.097 1.516,4.598 2.973,9.201 4.216,13.814 0.905,3.383 1.637,6.696 2.19,9.989 1.329,7.808 1.436,15.235 0.599,23.377 -0.105,0.997 -0.222,2.001 -0.352,3.009 C 12.603,-38.529 6.194,-18.267 0,0"
                            style={{
                              fill: "#c9c8c9",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path728"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g748">
                  <g id="g738" />
                  <g id="g746">
                    <g clipPath="url(#clipPath192)" id="g744">
                      <g
                        className="layer-container"
                        transform="translate(325.2983,642.165)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.831,14.109 -0.774,29.705 10.096,39.749 1.903,1.759 3.98,3.315 6.202,4.646 4.637,2.787 9.83,4.531 15.212,5.105 4.011,0.429 8.044,0.206 11.944,-0.658 2.35,-0.522 4.633,-1.293 6.84,-2.253 4.637,-2.018 9.239,-4.428 13.651,-7.254 11.239,-7.198 22.194,-15.192 32.527,-23.206 25.707,-19.953 50.421,-42.707 70.472,-68.338 15.801,-20.102 29.405,-42.916 36.594,-67.575 0.759,-2.572 1.652,-5.032 2.62,-7.354 0.973,-2.335 2.495,-4.301 4.42,-5.81 2.613,-2.049 5.844,-3.563 9.453,-4.251 47.837,-9.272 118.063,-31.572 121.922,-86.025 5.43,-76.637 -50.019,-189.319 -136.314,-234.642 -32.723,-17.186 -68.782,-26.22 -105.777,-26.22 -37.051,0 -73.132,9.034 -105.878,26.317 -86.196,45.356 -136.138,138.354 -136.138,234.545 0,56.758 80.75,78.167 126.372,86.67 5.766,1.093 10.534,4.298 13.338,8.658 1.217,1.894 2.483,3.766 3.76,5.628 2.804,4.088 5.372,8.889 7.126,14.2 1.515,4.6 2.97,9.208 4.208,13.824 0.904,3.388 1.631,6.703 2.178,9.998 1.313,7.807 1.41,15.243 0.568,23.392 -0.104,0.999 -0.222,2.002 -0.352,3.012 C 12.606,-38.551 6.197,-18.275 0,0"
                            style={{
                              fill: "#c7c7c7",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path740"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g760">
                  <g id="g750" />
                  <g id="g758">
                    <g clipPath="url(#clipPath196)" id="g756">
                      <g
                        className="layer-container"
                        transform="translate(325.6851,642.2978)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.796,14.004 -0.74,29.487 10.094,39.424 1.897,1.74 3.966,3.275 6.177,4.587 4.615,2.746 9.78,4.45 15.129,4.989 3.987,0.4 7.99,0.153 11.855,-0.732 2.329,-0.535 4.591,-1.318 6.775,-2.289 4.587,-2.041 9.152,-4.44 13.525,-7.257 11.164,-7.134 22.028,-15.097 32.279,-23.048 25.679,-19.933 50.374,-42.665 70.402,-68.269 15.786,-20.081 29.378,-42.877 36.548,-67.516 0.755,-2.569 1.632,-5.033 2.574,-7.368 0.95,-2.35 2.449,-4.337 4.353,-5.869 2.591,-2.082 5.813,-3.614 9.422,-4.298 47.707,-9.192 118.057,-31.384 122.024,-85.71 5.549,-75.994 -49.934,-189.03 -136.095,-234.282 -32.666,-17.155 -68.659,-26.173 -105.587,-26.173 -36.986,0 -72.999,9.018 -105.686,26.27 -86.063,45.287 -135.921,138.146 -135.921,234.185 0,56.733 81.252,78.004 126.688,86.397 5.773,1.086 10.528,4.339 13.267,8.784 1.187,1.927 2.424,3.835 3.672,5.733 2.736,4.16 5.26,8.994 7.011,14.303 1.515,4.605 2.969,9.215 4.202,13.834 0.902,3.394 1.624,6.711 2.165,10.008 1.296,7.805 1.385,15.249 0.539,23.408 -0.105,0.998 -0.224,2.003 -0.354,3.013 C 12.611,-38.573 6.199,-18.285 0,0"
                            style={{
                              fill: "#c6c5c6",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path752"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g772">
                  <g id="g762" />
                  <g id="g770">
                    <g clipPath="url(#clipPath200)" id="g768">
                      <g
                        className="layer-container"
                        transform="translate(326.0718,642.4296)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.761,13.899 -0.706,29.271 10.093,39.099 1.889,1.721 3.951,3.238 6.151,4.529 4.593,2.704 9.73,4.368 15.046,4.871 3.962,0.375 7.935,0.103 11.767,-0.805 2.308,-0.548 4.547,-1.342 6.71,-2.324 4.538,-2.059 9.059,-4.462 13.398,-7.262 11.075,-7.089 21.862,-15.002 32.032,-22.89 25.65,-19.91 50.325,-42.622 70.331,-68.196 15.771,-20.061 29.352,-42.841 36.501,-67.46 0.752,-2.563 1.614,-5.032 2.531,-7.38 0.923,-2.367 2.4,-4.373 4.285,-5.927 2.567,-2.116 5.781,-3.666 9.389,-4.346 47.578,-9.113 118.052,-31.198 122.127,-85.397 5.666,-75.352 -49.849,-188.74 -135.875,-233.918 -32.608,-17.126 -68.536,-26.128 -105.398,-26.128 -36.92,0 -72.867,9.002 -105.496,26.222 -85.929,45.217 -135.702,137.937 -135.702,233.824 0,56.71 81.755,77.845 127.004,86.124 5.78,1.08 10.523,4.381 13.196,8.911 1.157,1.96 2.364,3.903 3.583,5.838 2.669,4.234 5.148,9.097 6.898,14.406 1.514,4.608 2.965,9.223 4.196,13.845 0.899,3.398 1.616,6.718 2.15,10.017 1.281,7.803 1.36,15.257 0.51,23.424 -0.106,1 -0.225,2.004 -0.356,3.015 C 12.616,-38.594 6.202,-18.294 0,0"
                            style={{
                              fill: "#c5c4c5",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path764"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g784">
                  <g id="g774" />
                  <g id="g782">
                    <g clipPath="url(#clipPath204)" id="g780">
                      <g
                        className="layer-container"
                        transform="translate(326.4585,642.5615)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.726,13.795 -0.672,29.056 10.091,38.775 1.884,1.703 3.936,3.2 6.126,4.469 4.571,2.663 9.68,4.289 14.963,4.756 3.937,0.348 7.881,0.05 11.677,-0.879 2.289,-0.56 4.506,-1.368 6.646,-2.36 4.488,-2.08 8.966,-4.483 13.271,-7.265 10.988,-7.049 21.697,-14.906 31.786,-22.731 25.621,-19.89 50.277,-42.581 70.26,-68.127 15.756,-20.04 29.326,-42.804 36.455,-67.403 0.748,-2.559 1.594,-5.031 2.486,-7.393 0.898,-2.381 2.352,-4.408 4.218,-5.986 2.543,-2.151 5.75,-3.715 9.356,-4.391 47.449,-9.035 118.047,-31.013 122.231,-85.086 5.782,-74.707 -49.765,-188.449 -135.655,-233.556 -32.552,-17.094 -68.414,-26.08 -105.209,-26.08 -36.855,0 -72.735,8.986 -105.306,26.175 -85.795,45.147 -135.484,137.728 -135.484,233.461 0,56.686 82.275,77.59 127.32,85.853 5.789,1.062 10.516,4.421 13.125,9.038 1.127,1.992 2.304,3.972 3.494,5.942 2.602,4.309 5.036,9.202 6.784,14.51 1.515,4.611 2.964,9.229 4.19,13.855 0.897,3.402 1.609,6.726 2.137,10.026 1.264,7.801 1.335,15.264 0.48,23.44 -0.106,1 -0.225,2.006 -0.357,3.017 C 12.62,-38.615 6.204,-18.302 0,0"
                            style={{
                              fill: "#c3c2c3",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path776"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g796">
                  <g id="g786" />
                  <g id="g794">
                    <g clipPath="url(#clipPath208)" id="g792">
                      <g
                        className="layer-container"
                        transform="translate(326.8457,642.6943)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.691,13.689 -0.638,28.839 10.089,38.449 1.877,1.684 3.922,3.16 6.1,4.412 4.549,2.62 9.631,4.207 14.881,4.638 3.912,0.321 7.826,-0.001 11.588,-0.952 2.267,-0.574 4.463,-1.395 6.581,-2.397 4.438,-2.1 8.873,-4.503 13.144,-7.267 10.899,-7.007 21.531,-14.812 31.539,-22.574 25.592,-19.868 50.23,-42.538 70.19,-68.055 15.74,-20.022 29.3,-42.767 36.408,-67.346 0.745,-2.554 1.57,-5.032 2.44,-7.407 0.87,-2.398 2.307,-4.445 4.152,-6.044 2.52,-2.185 5.719,-3.768 9.324,-4.439 47.319,-8.955 118.039,-30.827 122.334,-84.77 5.897,-74.067 -49.681,-188.16 -135.436,-233.194 -32.495,-17.066 -68.292,-26.034 -105.02,-26.034 -36.789,0 -72.603,8.968 -105.114,26.126 -85.662,45.078 -135.267,137.52 -135.267,233.102 0,56.66 82.779,77.421 127.637,85.579 5.795,1.054 10.51,4.461 13.055,9.163 1.096,2.027 2.242,4.041 3.403,6.048 2.535,4.381 4.925,9.306 6.671,14.612 1.514,4.616 2.961,9.238 4.183,13.866 0.895,3.409 1.602,6.734 2.124,10.037 1.248,7.799 1.309,15.27 0.451,23.455 -0.107,1 -0.227,2.007 -0.358,3.017 C 12.625,-38.638 6.207,-18.311 0,0"
                            style={{
                              fill: "#c2c1c2",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path788"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g808">
                  <g id="g798" />
                  <g id="g806">
                    <g clipPath="url(#clipPath212)" id="g804">
                      <g
                        className="layer-container"
                        transform="translate(327.2324,642.8261)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.657,13.586 -0.604,28.622 10.087,38.126 1.871,1.664 3.907,3.121 6.075,4.352 4.527,2.578 9.581,4.126 14.798,4.522 3.888,0.294 7.771,-0.054 11.499,-1.026 2.247,-0.586 4.421,-1.418 6.516,-2.431 4.39,-2.121 8.78,-4.524 13.018,-7.272 10.81,-6.966 21.365,-14.717 31.292,-22.417 25.564,-19.845 50.181,-42.496 70.118,-67.985 15.726,-20.001 29.275,-42.729 36.362,-67.286 0.742,-2.552 1.552,-5.033 2.397,-7.421 0.844,-2.415 2.258,-4.48 4.083,-6.102 2.498,-2.22 5.687,-3.819 9.293,-4.487 47.19,-8.877 118.032,-30.64 122.437,-84.458 6.011,-73.425 -49.597,-187.87 -135.217,-232.832 -32.437,-17.035 -68.169,-25.987 -104.83,-25.987 -36.724,0 -72.471,8.952 -104.924,26.079 -85.529,45.009 -135.049,137.312 -135.049,232.74 0,56.638 83.282,77.253 127.953,85.308 5.802,1.046 10.505,4.501 12.984,9.289 1.066,2.06 2.182,4.11 3.315,6.154 2.466,4.453 4.812,9.408 6.556,14.715 1.515,4.618 2.959,9.244 4.177,13.875 0.893,3.414 1.595,6.742 2.111,10.046 1.231,7.798 1.283,15.278 0.421,23.472 -0.108,1.001 -0.227,2.007 -0.359,3.019 C 12.628,-38.659 6.209,-18.319 0,0"
                            style={{
                              fill: "#c0c0c0",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path800"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g820">
                  <g id="g810" />
                  <g id="g818">
                    <g clipPath="url(#clipPath216)" id="g816">
                      <g
                        className="layer-container"
                        transform="translate(327.6196,642.9579)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.622,13.481 -0.57,28.406 10.085,37.801 1.865,1.645 3.893,3.083 6.049,4.294 4.506,2.536 9.532,4.046 14.716,4.404 3.862,0.268 7.716,-0.104 11.41,-1.099 2.226,-0.598 4.378,-1.444 6.451,-2.466 4.341,-2.142 8.687,-4.546 12.892,-7.276 10.721,-6.924 21.198,-14.622 31.043,-22.259 25.537,-19.823 50.135,-42.454 70.048,-67.913 15.711,-19.981 29.249,-42.693 36.317,-67.23 0.738,-2.547 1.532,-5.032 2.351,-7.434 0.82,-2.429 2.211,-4.516 4.016,-6.16 2.475,-2.255 5.656,-3.87 9.261,-4.534 47.06,-8.798 118.022,-30.455 122.541,-84.145 6.124,-72.782 -49.513,-187.579 -134.998,-232.468 -32.38,-17.005 -68.046,-25.943 -104.641,-25.943 -36.659,0 -72.339,8.938 -104.733,26.032 -85.396,44.939 -134.831,137.104 -134.831,232.379 0,56.615 83.787,77.078 128.268,85.035 5.81,1.039 10.5,4.542 12.914,9.416 1.036,2.093 2.122,4.179 3.225,6.258 2.401,4.529 4.701,9.513 6.443,14.82 1.515,4.621 2.957,9.251 4.171,13.885 0.89,3.418 1.587,6.749 2.098,10.055 1.215,7.797 1.258,15.285 0.391,23.487 -0.109,1.002 -0.229,2.009 -0.361,3.021 C 12.633,-38.681 6.211,-18.327 0,0"
                            style={{
                              fill: "#bfbebf",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path812"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g832">
                  <g id="g822" />
                  <g id="g830">
                    <g clipPath="url(#clipPath220)" id="g828">
                      <g
                        className="layer-container"
                        transform="translate(328.0063,643.0908)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.587,13.376 -0.536,28.189 10.084,37.477 1.858,1.625 3.877,3.043 6.023,4.233 4.484,2.495 9.482,3.965 14.632,4.288 3.839,0.241 7.663,-0.156 11.323,-1.172 2.205,-0.612 4.334,-1.469 6.385,-2.502 4.292,-2.163 8.595,-4.567 12.765,-7.28 10.633,-6.881 21.033,-14.526 30.798,-22.101 25.507,-19.8 50.086,-42.411 69.976,-67.842 15.697,-19.961 29.224,-42.656 36.27,-67.172 0.735,-2.543 1.514,-5.032 2.306,-7.449 0.796,-2.443 2.165,-4.551 3.95,-6.217 2.451,-2.288 5.625,-3.922 9.227,-4.581 46.932,-8.719 118.015,-30.27 122.645,-83.831 6.236,-72.14 -49.428,-187.289 -134.779,-232.108 -32.323,-16.973 -67.923,-25.895 -104.451,-25.895 -36.593,0 -72.207,8.922 -104.543,25.984 -85.261,44.87 -134.612,136.896 -134.612,232.019 0,56.589 84.291,76.908 128.584,84.761 5.817,1.032 10.495,4.584 12.843,9.543 1.007,2.127 2.062,4.248 3.136,6.364 2.334,4.601 4.589,9.616 6.33,14.921 1.514,4.626 2.954,9.259 4.164,13.897 0.887,3.423 1.581,6.757 2.084,10.063 1.198,7.796 1.233,15.293 0.362,23.503 -0.109,1.003 -0.23,2.011 -0.362,3.024 C 12.637,-38.703 6.213,-18.338 0,0"
                            style={{
                              fill: "#bebdbe",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path824"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g844">
                  <g id="g834" />
                  <g id="g842">
                    <g clipPath="url(#clipPath224)" id="g840">
                      <g
                        className="layer-container"
                        transform="translate(328.3931,643.2216)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.552,13.272 -0.502,27.975 10.082,37.153 1.852,1.608 3.862,3.004 5.998,4.175 4.462,2.453 9.432,3.885 14.55,4.172 3.813,0.214 7.607,-0.209 11.232,-1.246 2.185,-0.625 4.293,-1.493 6.322,-2.537 4.242,-2.184 8.502,-4.588 12.638,-7.284 10.544,-6.84 20.866,-14.431 30.55,-21.943 25.479,-19.779 50.039,-42.37 69.906,-67.772 15.681,-19.941 29.198,-42.618 36.224,-67.114 0.731,-2.539 1.494,-5.032 2.262,-7.461 0.77,-2.46 2.116,-4.588 3.882,-6.278 2.426,-2.323 5.592,-3.972 9.195,-4.628 46.803,-8.639 118.004,-30.084 122.748,-83.517 6.348,-71.498 -49.343,-186.999 -134.56,-231.744 -32.265,-16.946 -67.8,-25.85 -104.262,-25.85 -36.528,0 -72.075,8.904 -104.352,25.937 -85.128,44.798 -134.394,136.686 -134.394,231.657 0,56.564 84.794,76.739 128.901,84.489 5.823,1.023 10.489,4.625 12.771,9.669 0.978,2.16 2.002,4.315 3.047,6.469 2.267,4.675 4.478,9.72 6.216,15.025 1.515,4.629 2.952,9.266 4.158,13.907 0.885,3.427 1.574,6.764 2.071,10.073 1.182,7.794 1.208,15.3 0.332,23.519 -0.109,1.003 -0.23,2.011 -0.363,3.024 C 12.642,-38.724 6.216,-18.345 0,0"
                            style={{
                              fill: "#bcbbbc",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path836"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g856">
                  <g id="g846" />
                  <g id="g854">
                    <g clipPath="url(#clipPath228)" id="g852">
                      <g
                        className="layer-container"
                        transform="translate(328.7798,643.3544)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.517,13.166 -0.467,27.757 10.081,36.828 1.845,1.588 3.847,2.965 5.972,4.116 4.44,2.411 9.383,3.803 14.467,4.055 3.789,0.187 7.553,-0.261 11.144,-1.319 2.164,-0.639 4.25,-1.519 6.256,-2.574 4.193,-2.204 8.409,-4.609 12.512,-7.288 10.455,-6.797 20.7,-14.336 30.303,-21.784 25.45,-19.758 49.992,-42.327 69.835,-67.701 15.666,-19.921 29.172,-42.581 36.177,-67.058 0.73,-2.533 1.476,-5.029 2.218,-7.473 0.746,-2.476 2.068,-4.623 3.813,-6.335 2.405,-2.358 5.563,-4.025 9.164,-4.675 46.673,-8.562 117.993,-29.9 122.851,-83.205 6.458,-70.857 -49.259,-186.709 -134.34,-231.383 -32.208,-16.914 -67.678,-25.802 -104.073,-25.802 -36.462,0 -71.942,8.888 -104.161,25.889 -84.995,44.73 -134.177,136.478 -134.177,231.296 0,56.541 85.299,76.566 129.218,84.217 5.83,1.015 10.484,4.666 12.7,9.796 0.948,2.193 1.943,4.384 2.958,6.573 2.201,4.748 4.366,9.824 6.102,15.129 1.515,4.632 2.951,9.272 4.152,13.916 0.883,3.434 1.566,6.773 2.057,10.083 1.167,7.793 1.183,15.307 0.303,23.535 -0.11,1.004 -0.231,2.012 -0.364,3.025 C 12.646,-38.745 6.218,-18.354 0,0"
                            style={{
                              fill: "#bbbabb",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path848"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g868">
                  <g id="g858" />
                  <g id="g866">
                    <g clipPath="url(#clipPath232)" id="g864">
                      <g
                        className="layer-container"
                        transform="translate(329.1665,643.4872)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.481,13.061 -0.434,27.539 10.079,36.503 1.839,1.569 3.833,2.927 5.946,4.058 4.419,2.369 9.333,3.722 14.385,3.937 3.764,0.161 7.499,-0.312 11.055,-1.393 2.143,-0.651 4.208,-1.542 6.191,-2.608 4.144,-2.225 8.317,-4.631 12.386,-7.291 10.366,-6.757 20.534,-14.241 30.056,-21.627 25.421,-19.736 49.943,-42.285 69.763,-67.631 15.652,-19.901 29.147,-42.545 36.132,-67 0.726,-2.529 1.456,-5.03 2.172,-7.487 0.722,-2.49 2.022,-4.659 3.747,-6.394 2.381,-2.392 5.531,-4.075 9.132,-4.721 46.543,-8.484 117.876,-29.724 122.954,-82.892 6.43,-70.228 -49.175,-186.419 -134.121,-231.019 -32.15,-16.885 -67.555,-25.757 -103.883,-25.757 -36.397,0 -71.81,8.872 -103.971,25.842 -84.861,44.66 -133.959,136.269 -133.959,230.934 0,56.517 85.803,76.397 129.534,83.944 5.837,1.008 10.48,4.707 12.63,9.921 0.918,2.228 1.882,4.454 2.868,6.679 2.135,4.823 4.254,9.929 5.988,15.232 1.515,4.637 2.948,9.281 4.146,13.928 0.881,3.438 1.559,6.779 2.044,10.092 1.15,7.79 1.157,15.314 0.273,23.551 -0.11,1.004 -0.232,2.013 -0.365,3.026 C 12.65,-38.769 6.221,-18.363 0,0"
                            style={{
                              fill: "#b9b8b9",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path860"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g880">
                  <g id="g870" />
                  <g id="g878">
                    <g clipPath="url(#clipPath236)" id="g876">
                      <g
                        className="layer-container"
                        transform="translate(329.5532,643.6181)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.446,12.957 -0.399,27.325 10.078,36.18 1.832,1.549 3.818,2.887 5.92,3.998 4.397,2.328 9.284,3.641 14.302,3.821 3.739,0.134 7.444,-0.364 10.966,-1.466 2.123,-0.665 4.165,-1.568 6.127,-2.643 4.094,-2.245 8.223,-4.652 12.258,-7.296 C 69.93,25.88 80.02,18.447 89.46,11.125 c 25.393,-19.715 49.896,-42.242 69.693,-67.56 15.637,-19.88 29.12,-42.506 36.085,-66.942 0.723,-2.525 1.438,-5.029 2.128,-7.5 0.697,-2.507 1.974,-4.696 3.68,-6.452 2.357,-2.427 5.499,-4.127 9.1,-4.77 46.414,-8.404 117.877,-29.538 123.057,-82.578 6.558,-69.585 -49.091,-186.129 -133.902,-230.658 -32.094,-16.854 -67.433,-25.709 -103.694,-25.709 -36.332,0 -71.678,8.855 -103.78,25.792 -84.728,44.592 -133.741,136.063 -133.741,230.575 0,56.493 86.307,76.227 129.85,83.672 5.844,0.999 10.476,4.749 12.559,10.048 0.889,2.261 1.823,4.522 2.778,6.783 2.07,4.897 4.144,10.034 5.875,15.336 1.515,4.64 2.947,9.287 4.14,13.938 0.879,3.443 1.552,6.788 2.031,10.1 1.133,7.79 1.131,15.321 0.244,23.567 -0.112,1.005 -0.234,2.015 -0.368,3.029 C 12.655,-38.789 6.224,-18.371 0,0"
                            style={{
                              fill: "#b8b7b8",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path872"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g892">
                  <g id="g882" />
                  <g id="g890">
                    <g clipPath="url(#clipPath240)" id="g888">
                      <g
                        className="layer-container"
                        transform="translate(329.9404,643.7509)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.386,12.861 -0.366,27.107 10.076,35.854 1.826,1.531 3.802,2.849 5.895,3.94 4.375,2.286 9.234,3.56 14.218,3.704 3.715,0.107 7.391,-0.416 10.878,-1.54 2.102,-0.677 4.122,-1.592 6.061,-2.678 4.046,-2.265 8.131,-4.674 12.132,-7.3 10.19,-6.671 20.203,-14.05 29.562,-21.311 25.364,-19.692 49.848,-42.199 69.623,-67.488 15.621,-19.862 29.095,-42.47 36.038,-66.886 0.72,-2.521 1.419,-5.027 2.084,-7.513 0.672,-2.522 1.923,-4.734 3.612,-6.511 2.328,-2.465 5.468,-4.176 9.067,-4.816 46.285,-8.325 117.879,-29.351 123.161,-82.264 6.687,-68.943 -49.006,-185.839 -133.683,-230.295 -32.036,-16.826 -67.309,-25.664 -103.504,-25.664 -36.266,0 -71.547,8.838 -103.589,25.745 -84.595,44.522 -133.523,135.853 -133.523,230.214 0,56.468 86.812,76.044 130.165,83.398 5.852,0.992 10.473,4.791 12.489,10.175 0.86,2.295 1.763,4.591 2.689,6.888 2.004,4.97 4.031,10.138 5.761,15.439 1.515,4.643 2.944,9.295 4.134,13.948 0.876,3.448 1.544,6.796 2.018,10.11 1.116,7.788 1.105,15.329 0.213,23.582 -0.111,1.006 -0.234,2.017 -0.368,3.032 C 12.659,-38.811 6.263,-18.367 0,0"
                            style={{
                              fill: "#b7b6b7",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path884"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g904">
                  <g id="g894" />
                  <g id="g902">
                    <g clipPath="url(#clipPath244)" id="g900">
                      <g
                        className="layer-container"
                        transform="translate(330.3276,643.8828)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.351,12.757 -0.332,26.892 10.073,35.53 1.82,1.512 3.789,2.811 5.87,3.88 4.353,2.245 9.184,3.481 14.136,3.589 3.69,0.08 7.336,-0.468 10.788,-1.613 2.082,-0.691 4.081,-1.618 5.997,-2.715 3.996,-2.286 8.038,-4.694 12.006,-7.304 10.101,-6.63 20.036,-13.956 29.315,-21.152 25.335,-19.671 49.8,-42.158 69.551,-67.418 15.606,-19.841 29.069,-42.434 35.993,-66.827 0.715,-2.518 1.399,-5.029 2.038,-7.529 0.648,-2.537 1.876,-4.768 3.545,-6.567 2.306,-2.499 5.437,-4.229 9.035,-4.863 46.156,-8.247 117.882,-29.166 123.264,-81.952 6.816,-68.299 -48.921,-185.548 -133.463,-229.934 -31.98,-16.794 -67.188,-25.617 -103.315,-25.617 -36.201,0 -71.414,8.823 -103.399,25.698 -84.461,44.452 -133.305,135.646 -133.305,229.853 0,56.445 87.316,75.875 130.482,83.126 5.859,0.984 10.475,4.829 12.417,10.301 0.834,2.327 1.708,4.66 2.601,6.994 1.945,5.041 3.919,10.241 5.647,15.541 1.515,4.648 2.942,9.302 4.127,13.959 0.874,3.453 1.537,6.803 2.005,10.12 1.1,7.786 1.08,15.335 0.184,23.597 -0.113,1.007 -0.236,2.019 -0.369,3.032 C 12.663,-38.832 6.266,-18.377 0,0"
                            style={{
                              fill: "#b5b4b5",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path896"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g916">
                  <g id="g906" />
                  <g id="g914">
                    <g clipPath="url(#clipPath248)" id="g912">
                      <g
                        className="layer-container"
                        transform="translate(330.7144,644.0156)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.315,12.652 -0.297,26.674 10.072,35.205 1.813,1.492 3.774,2.772 5.844,3.822 4.331,2.202 9.134,3.399 14.053,3.47 3.665,0.054 7.281,-0.518 10.699,-1.685 2.061,-0.704 4.038,-1.645 5.933,-2.751 3.946,-2.306 7.945,-4.715 11.878,-7.306 10.013,-6.589 19.871,-13.861 29.068,-20.996 25.307,-19.65 49.753,-42.116 69.481,-67.347 15.591,-19.821 29.043,-42.396 35.947,-66.769 0.712,-2.514 1.379,-5.029 1.993,-7.542 0.623,-2.553 1.829,-4.803 3.477,-6.626 2.284,-2.533 5.406,-4.281 9.003,-4.911 46.027,-8.168 117.883,-28.98 123.368,-81.638 6.944,-67.657 -48.837,-185.258 -133.244,-229.571 -31.923,-16.764 -67.065,-25.571 -103.126,-25.571 -36.136,0 -71.282,8.807 -103.208,25.651 -84.327,44.382 -133.087,135.435 -133.087,229.491 0,56.421 87.819,75.708 130.798,82.854 5.865,0.976 10.467,4.871 12.347,10.426 0.802,2.362 1.646,4.73 2.511,7.1 1.877,5.116 3.807,10.344 5.534,15.645 1.514,4.651 2.939,9.309 4.12,13.968 0.872,3.459 1.53,6.811 1.991,10.129 1.084,7.785 1.055,15.344 0.155,23.615 -0.113,1.007 -0.236,2.019 -0.371,3.032 C 12.667,-38.855 6.27,-18.385 0,0"
                            style={{
                              fill: "#b4b3b4",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path908"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g928">
                  <g id="g918" />
                  <g id="g926">
                    <g clipPath="url(#clipPath252)" id="g924">
                      <g
                        className="layer-container"
                        transform="translate(331.1011,644.1464)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -4.28,12.549 -0.263,26.46 10.07,34.882 1.807,1.473 3.759,2.732 5.819,3.763 4.309,2.161 9.085,3.318 13.97,3.354 3.641,0.027 7.227,-0.571 10.611,-1.76 2.041,-0.717 3.995,-1.668 5.867,-2.785 3.898,-2.326 7.852,-4.737 11.752,-7.311 9.924,-6.547 19.705,-13.767 28.821,-20.837 25.278,-19.628 49.705,-42.075 69.41,-67.277 15.576,-19.801 29.017,-42.359 35.9,-66.713 0.709,-2.507 1.361,-5.027 1.949,-7.553 0.599,-2.569 1.781,-4.839 3.41,-6.685 2.261,-2.566 5.374,-4.332 8.971,-4.958 45.896,-8.089 117.885,-28.793 123.471,-81.325 7.072,-67.014 -48.753,-184.968 -133.025,-229.209 -31.865,-16.734 -66.942,-25.524 -102.937,-25.524 -36.07,0 -71.15,8.79 -103.017,25.602 -84.194,44.314 -132.869,135.229 -132.869,229.131 0,56.397 88.324,75.529 131.114,82.581 5.873,0.968 10.459,4.916 12.276,10.554 0.771,2.395 1.586,4.799 2.421,7.204 1.809,5.191 3.697,10.449 5.421,15.748 1.515,4.654 2.937,9.316 4.115,13.979 0.869,3.463 1.522,6.819 1.977,10.139 1.067,7.782 1.03,15.35 0.125,23.629 -0.113,1.009 -0.237,2.019 -0.372,3.036 C 12.672,-38.875 6.272,-18.393 0,0"
                            style={{
                              fill: "#b2b1b2",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path920"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="g940">
                  <g id="g930" />
                  <g id="g938">
                    <g clipPath="url(#clipPath256)" id="g936">
                      <g
                        className="layer-container"
                        transform="translate(527.9077,190.0956)"
                      >
                        <g className="space">
                          <path
                            d="m 0,0 c -31.809,-16.705 -66.82,-25.479 -102.748,-25.479 -36.004,0 -71.017,8.774 -102.826,25.555 -84.06,44.244 -132.651,135.02 -132.651,228.77 0,56.373 88.79,75.595 131.431,82.308 5.874,0.992 10.45,4.959 12.205,10.68 3.737,12.281 8.619,24.715 11.747,37.15 2.898,11.594 3.356,21.969 2.059,33.793 -2.288,20.368 -9.077,42.032 -15.637,61.407 -4.272,12.433 -0.229,26.242 10.069,34.556 5.568,4.5 12.51,6.942 19.68,6.942 5.797,0 11.442,-1.602 16.324,-4.655 13.73,-8.162 27.614,-18.23 40.2,-27.994 25.249,-19.605 49.658,-42.031 69.338,-67.205 17.163,-21.816 31.733,-46.99 37.758,-74.223 1.374,-6.179 6.103,-10.679 12.282,-11.748 C 54.998,301.848 127.117,281.25 132.805,228.846 140.006,162.475 84.137,44.168 0,0"
                            style={{
                              fill: "#b1b0b1",
                              fillOpacity: "1",
                              fillRule: "evenodd",
                              stroke: "none",
                            }}
                            id="path932"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            {/* Gases layer outside */}
            <g
              className="layer-container"
              transform="translate(660.7124,418.9413)"
            >
              <g className="gases-outside">
                <path
                  d="m 0,0 c 0,-93.826 -48.668,-184.678 -132.805,-228.846 -31.808,-16.705 -66.82,-25.478 -102.747,-25.478 -36.005,0 -71.018,8.773 -102.826,25.554 -84.061,44.245 -132.652,135.02 -132.652,228.77 0,56.373 88.79,75.596 131.431,82.309 5.874,0.992 10.45,4.959 12.205,10.679 3.737,12.282 8.62,24.715 11.747,37.151 2.898,11.593 3.356,21.968 2.06,33.793 -2.289,20.367 -9.078,42.031 -15.638,61.406 -4.272,12.433 -0.229,26.242 10.069,34.557 5.569,4.5 12.51,6.941 19.68,6.941 5.797,0 11.442,-1.602 16.325,-4.654 13.73,-8.162 27.613,-18.231 40.199,-27.995 25.249,-19.605 49.658,-42.031 69.339,-67.205 17.162,-21.816 31.732,-46.99 37.758,-74.222 1.374,-6.18 6.102,-10.68 12.282,-11.748 C -77.807,73.002 0,52.711 0,0"
                  style={{
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                    stroke: "none",
                  }}
                  id="path948"
                />
              </g>
            </g>
            {/* Solid layer */}
            <g
              className="layer-container"
              transform="translate(645.4565,418.4355)"
            >
              <g className="solid">
                <path
                  d="m 0,0 c 0,-131.803 -98.442,-238.562 -220.263,-238.562 -121.669,0 -220.256,106.759 -220.256,238.562 z"
                  style={{
                    fill: "#4c2719",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                  }}
                  id="path952"
                />
              </g>
            </g>
            {/* Gases layer inside */}
            <g
              className="layer-container"
              transform="translate(425.1934,355.5527)"
            >
              <g className="gases-inside">
                <path
                  d="m 0,0 c 121.382,0 220.263,28.201 220.263,62.883 0,34.672 -98.881,62.881 -220.263,62.881 -121.235,0 -220.255,-28.209 -220.255,-62.881 C -220.255,28.201 -121.235,0 0,0"
                  style={{
                    fill: "#ffffff",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                    stroke: "none",
                  }}
                  id="path956"
                />
              </g>
            </g>
            {/* Liquid layer */}
            <g
              className="layer-container"
              transform="translate(425.1934,367.4941)"
            >
              <g className="liquid">
                <path
                  d="m 0,0 c 110.055,0 199.935,22.879 199.935,50.941 0,28.051 -89.88,50.93 -199.935,50.93 -110.054,0 -199.784,-22.879 -199.784,-50.93 C -199.784,22.879 -110.054,0 0,0"
                  style={{
                    fill: "#aedbf0",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                  }}
                  id="path960"
                />
              </g>
            </g>
            {/* Fire layer */}
            <g
              className="layer-container"
              transform="translate(356.0859,670.5214)"
            >
              <g className="fire">
                <path
                  d="M 0,0 C 0,0 207.625,-124.033 128.058,-235.543 103.375,-270.215 57.35,-277.699 27.875,-258.707 -2.324,-239.566 -9.15,-202.592 0,-170.213 15.533,-115.396 34.991,-101.873 0,0"
                  style={{
                    fill: "#ff5964",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                  }}
                  id="path964"
                />
              </g>
            </g>
            {/* Light layer */}
            <g
              className="layer-container"
              transform="translate(420.1152,423.4706)"
            >
              <g className="light">
                <path
                  d="m 0,0 c -9.147,0 -17.424,2.301 -24.25,6.619 -22.939,14.676 -24.394,43.889 -18.584,64.455 2.614,9.069 5.372,16.987 7.843,24.61 10.597,30.935 17.13,54.392 8.854,97.406 C 8.278,165.322 49.363,124.031 58.513,81.441 62.866,60.717 58.8,41.871 46.025,24.029 35.282,8.922 18.003,0 0,0"
                  style={{
                    fill: "#ffb20f",
                    fillOpacity: "1",
                    fillRule: "evenodd",
                  }}
                  id="path968"
                />
              </g>
            </g>
            {/* Electro-magnetic layer */}
            <g className="layer-container" transform="translate(290,400)">
              <g className="electro-magnetic">
                <path
                  style={{
                    transform: "scale(0.25)",
                    fill: "transparent",
                    strokeOpacity: "1",
                  }}
                  d="M 531.81933,395.85496 C 531.30585,394.47996 525.53381,373.99165 518.99259,350.32538 L 507.09945,307.29581 L 461.93677,294.82538 C 437.09729,287.96665 416.92367,282.10581 417.10649,281.80129 C 417.28932,281.49678 437.61472,275.65705 462.27406,268.82412 L 507.10921,256.40062 L 519.51545,211.62779 C 526.33887,187.00273 532.21052,166.85496 532.56355,166.85496 C 532.91658,166.85496 538.78823,187.00273 545.61165,211.62779 L 558.01789,256.40062 L 602.79072,268.80686 C 627.41578,275.63028 647.56355,281.50193 647.56355,281.85496 C 647.56355,282.20799 627.41471,288.07993 602.78834,294.90372 L 558.01314,307.31061 L 545.38303,352.83279 C 534.97499,390.34607 532.58868,397.91513 531.81933,395.85496 z"
                  id="path2438"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
